/**
 * @module Icon
 * Pour extraite depuis fontawesome :
 * - dans network : click-droit sur la requête par catégories (celle avec nbHits environ 70-80) puis sélectionnez copy > copy response
 * - dans la console : saisissez "r = " puis collez le résultat puis pressez la touche "enter"
 * - dans la console : saisissez "s = r.hits.map(h => { return { label: h.name, icons: h.icons } })" puis pressez la touche "enter"
 * - dans la console : saisissez "copy(s)" pour avoir le résultat dans le presse-papier
 * - collez le résutat ici après "export default" (eventuellement mettre en page avant avec https://jsonlint.com/)
 * - remplacez "    "" par "    "fa-"
 * - mettez à jour le npm de fontawesome PRO avec : npm install --save @fortawesome/fontawesome-pro
 * - puis mettez à jour le npm de fontawesome FREE avec : npm install --save @fortawesome/fontawesome-free
 */
export default [
    {
        "label": "writing",
        "icons": [
            "fa-pencil-alt",
            "fa-newspaper",
            "fa-sticky-note",
            "fa-envelope",
            "fa-pencil",
            "fa-folder",
            "fa-pen-square",
            "fa-eraser",
            "fa-thumbtack",
            "fa-book",
            "fa-quote-right",
            "fa-paper-plane",
            "fa-file",
            "fa-archive",
            "fa-blog",
            "fa-edit",
            "fa-paperclip",
            "fa-quote-left",
            "fa-pen-alt",
            "fa-folder-open",
            "fa-envelope-open",
            "fa-keyboard",
            "fa-file-alt",
            "fa-paragraph",
            "fa-bookmark",
            "fa-pen"
        ]
    },
    {
        "label": "winter",
        "icons": [
            "fa-skating",
            "fa-skiing-nordic",
            "fa-glass-whiskey",
            "fa-ball-pile",
            "fa-truck-plow",
            "fa-chimney",
            "fa-skiing",
            "fa-ice-skate",
            "fa-snowmobile",
            "fa-snowplow",
            "fa-frosty-head",
            "fa-temperature-frigid",
            "fa-scarf",
            "fa-boot",
            "fa-snowboarding",
            "fa-tree-large",
            "fa-ski-lift",
            "fa-ski-jump",
            "fa-hat-winter",
            "fa-glass-whiskey-rocks",
            "fa-sledding",
            "fa-mug-tea",
            "fa-ear-muffs",
            "fa-globe-snow",
            "fa-mitten",
            "fa-tram",
            "fa-igloo",
            "fa-snowflakes",
            "fa-shovel-snow",
            "fa-icicles",
            "fa-mug-marshmallows"
        ]
    },
    {
        "label": "weather",
        "icons": [
            "fa-moon",
            "fa-temperature-down",
            "fa-wind-warning",
            "fa-windsock",
            "fa-thunderstorm",
            "fa-humidity",
            "fa-cloud-showers-heavy",
            "fa-cloud-moon-rain",
            "fa-clouds-moon",
            "fa-temperature-low",
            "fa-bolt",
            "fa-stars",
            "fa-fog",
            "fa-volcano",
            "fa-moon-stars",
            "fa-raindrops",
            "fa-cloud-rainbow",
            "fa-cloud-hail-mixed",
            "fa-house-flood",
            "fa-dewpoint",
            "fa-snow-blowing",
            "fa-sparkles",
            "fa-sunset",
            "fa-cloud-hail",
            "fa-cloud-meatball",
            "fa-sunrise",
            "fa-sun-haze",
            "fa-heat",
            "fa-temperature-frigid",
            "fa-smoke",
            "fa-hurricane",
            "fa-smog",
            "fa-water-lower",
            "fa-meteor",
            "fa-temperature-hot",
            "fa-cloud-sun-rain",
            "fa-rainbow",
            "fa-temperature-up",
            "fa-eclipse-alt",
            "fa-cloud-showers",
            "fa-fire-smoke",
            "fa-thunderstorm-moon",
            "fa-sun",
            "fa-cloud-rain",
            "fa-umbrella",
            "fa-moon-cloud",
            "fa-thunderstorm-sun",
            "fa-temperature-high",
            "fa-poo-storm",
            "fa-water-rise",
            "fa-eclipse",
            "fa-snowflake",
            "fa-wind",
            "fa-sun-dust",
            "fa-cloud",
            "fa-clouds",
            "fa-water",
            "fa-sun-cloud",
            "fa-cloud-sun",
            "fa-snowflakes",
            "fa-cloud-moon",
            "fa-cloud-drizzle",
            "fa-clouds-sun",
            "fa-cloud-sleet",
            "fa-cloud-snow",
            "fa-tornado"
        ]
    },
    {
        "label": "vehicles",
        "icons": [
            "fa-bicycle",
            "fa-drone",
            "fa-horse-saddle",
            "fa-wheelchair",
            "fa-starfighter-alt",
            "fa-shuttle-van",
            "fa-car",
            "fa-truck-plow",
            "fa-car-building",
            "fa-helicopter",
            "fa-starship-freighter",
            "fa-plane-alt",
            "fa-car-bus",
            "fa-motorcycle",
            "fa-truck",
            "fa-subway",
            "fa-rv",
            "fa-snowmobile",
            "fa-plane",
            "fa-fighter-jet",
            "fa-rocket",
            "fa-snowplow",
            "fa-car-tilt",
            "fa-ambulance",
            "fa-bus-alt",
            "fa-pegasus",
            "fa-ship",
            "fa-tractor",
            "fa-starfighter",
            "fa-sleigh",
            "fa-horse",
            "fa-train",
            "fa-car-side",
            "fa-car-bump",
            "fa-starship",
            "fa-paper-plane",
            "fa-drone-alt",
            "fa-shopping-cart",
            "fa-ufo",
            "fa-ski-lift",
            "fa-truck-pickup",
            "fa-accessible-icon",
            "fa-baby-carriage",
            "fa-tram",
            "fa-rocket-launch",
            "fa-car-alt",
            "fa-ufo-beam",
            "fa-taxi",
            "fa-flux-capacitor",
            "fa-bus",
            "fa-car-crash",
            "fa-truck-monster",
            "fa-space-shuttle",
            "fa-cars"
        ]
    },
    {
        "label": "users-people",
        "icons": [
            "fa-restroom",
            "fa-digging",
            "fa-people-arrows",
            "fa-skating",
            "fa-wheelchair",
            "fa-skiing-nordic",
            "fa-user-slash",
            "fa-frown",
            "fa-street-view",
            "fa-user-chart",
            "fa-user-injured",
            "fa-blind",
            "fa-id-card-alt",
            "fa-user-alt",
            "fa-head-vr",
            "fa-user-headset",
            "fa-child",
            "fa-id-card",
            "fa-user-shield",
            "fa-hiking",
            "fa-user-lock",
            "fa-meh",
            "fa-user-plus",
            "fa-user-music",
            "fa-skiing",
            "fa-swimmer",
            "fa-baby",
            "fa-user-friends",
            "fa-user-tie",
            "fa-user-md-chat",
            "fa-snowmobile",
            "fa-walking",
            "fa-user-hard-hat",
            "fa-user-edit",
            "fa-person-dolly",
            "fa-user-astronaut",
            "fa-head-side",
            "fa-female",
            "fa-pray",
            "fa-user-nurse",
            "fa-users-slash",
            "fa-smile",
            "fa-user-check",
            "fa-user-clock",
            "fa-user-circle",
            "fa-address-card",
            "fa-users-medical",
            "fa-user-unlock",
            "fa-people-carry",
            "fa-user-cowboy",
            "fa-users-class",
            "fa-user-cog",
            "fa-bed",
            "fa-snowboarding",
            "fa-user-graduate",
            "fa-id-badge",
            "fa-file-user",
            "fa-user",
            "fa-ski-lift",
            "fa-user-ninja",
            "fa-ski-jump",
            "fa-angel",
            "fa-power-off",
            "fa-accessible-icon",
            "fa-user-alt-slash",
            "fa-address-book",
            "fa-sledding",
            "fa-poll-people",
            "fa-poo",
            "fa-user-md",
            "fa-person-sign",
            "fa-user-times",
            "fa-male",
            "fa-user-tag",
            "fa-person-dolly-empty",
            "fa-person-booth",
            "fa-user-crown",
            "fa-user-minus",
            "fa-chalkboard-teacher",
            "fa-users-cog",
            "fa-biking",
            "fa-biking-mountain",
            "fa-users-crown",
            "fa-users",
            "fa-user-secret",
            "fa-portrait",
            "fa-running",
            "fa-person-carry"
        ]
    },
    {
        "label": "travel",
        "icons": [
            "fa-cocktail",
            "fa-luggage-cart",
            "fa-horse-saddle",
            "fa-archway",
            "fa-map",
            "fa-dumbbell",
            "fa-tv",
            "fa-caravan-alt",
            "fa-map-marked-alt",
            "fa-phone-rotary",
            "fa-tree-palm",
            "fa-suitcase",
            "fa-shuttle-van",
            "fa-swimming-pool",
            "fa-concierge-bell",
            "fa-glass-martini-alt",
            "fa-monument",
            "fa-cactus",
            "fa-suitcase-rolling",
            "fa-plane-arrival",
            "fa-car-bus",
            "fa-map-marked",
            "fa-glass-martini",
            "fa-swimmer",
            "fa-wine-glass-alt",
            "fa-spa",
            "fa-umbrella-beach",
            "fa-atlas",
            "fa-rv",
            "fa-plane",
            "fa-island-tropical",
            "fa-bus-alt",
            "fa-globe-asia",
            "fa-hot-tub",
            "fa-bed",
            "fa-globe-americas",
            "fa-globe-europe",
            "fa-wine-glass",
            "fa-caravan",
            "fa-plane-departure",
            "fa-hotel",
            "fa-rings-wedding",
            "fa-passport",
            "fa-tram",
            "fa-tv-alt",
            "fa-taxi",
            "fa-flux-capacitor",
            "fa-bus",
            "fa-wagon-covered",
            "fa-globe-africa",
            "fa-cars"
        ]
    },
    {
        "label": "toggle",
        "icons": [
            "fa-bullseye-arrow",
            "fa-star-half-alt",
            "fa-star-half",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-check-circle",
            "fa-volume-slash",
            "fa-location-slash",
            "fa-wifi",
            "fa-volume",
            "fa-location",
            "fa-toggle-on",
            "fa-bullseye",
            "fa-star",
            "fa-wifi-slash",
            "fa-toggle-off",
            "fa-dot-circle",
            "fa-circle"
        ]
    },
    {
        "label": "summer",
        "icons": [
            "fa-shish-kebab",
            "fa-tree-palm",
            "fa-swimming-pool",
            "fa-anchor",
            "fa-swimmer",
            "fa-kite",
            "fa-lemon",
            "fa-volleyball-ball",
            "fa-umbrella-beach",
            "fa-island-tropical",
            "fa-fish",
            "fa-temperature-hot",
            "fa-ice-cream",
            "fa-glass-citrus",
            "fa-sun",
            "fa-hotdog",
            "fa-glass",
            "fa-water",
            "fa-biking",
            "fa-biking-mountain",
            "fa-sunglasses"
        ]
    },
    {
        "label": "status",
        "icons": [
            "fa-exclamation-triangle",
            "fa-star-half-alt",
            "fa-parking-circle",
            "fa-volume-mute",
            "fa-video-slash",
            "fa-user-slash",
            "fa-phone-alt",
            "fa-bell-school-slash",
            "fa-plus",
            "fa-thumbs-down",
            "fa-question-circle",
            "fa-parking",
            "fa-microphone-alt",
            "fa-lock",
            "fa-star-half",
            "fa-signal-alt-2",
            "fa-calendar-week",
            "fa-signal",
            "fa-file-minus",
            "fa-tint-slash",
            "fa-sign-out-alt",
            "fa-info",
            "fa-exclamation-square",
            "fa-door-open",
            "fa-user-alt",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-map-marker-alt",
            "fa-bell",
            "fa-plus-octagon",
            "fa-calendar-exclamation",
            "fa-file-times",
            "fa-thermometer-empty",
            "fa-lock-open-alt",
            "fa-video",
            "fa-shield-check",
            "fa-microphone-alt-slash",
            "fa-volume-slash",
            "fa-bell-school",
            "fa-calendar-check",
            "fa-print",
            "fa-question-square",
            "fa-signal-1",
            "fa-plus-circle",
            "fa-comment-slash",
            "fa-volume-off",
            "fa-signal-2",
            "fa-print-slash",
            "fa-minus-square",
            "fa-stream",
            "fa-thumbs-up",
            "fa-plus-square",
            "fa-location-slash",
            "fa-gas-pump-slash",
            "fa-volume-up",
            "fa-folder",
            "fa-wifi-2",
            "fa-wifi",
            "fa-signal-slash",
            "fa-volume",
            "fa-map-marker-alt-slash",
            "fa-thermometer-full",
            "fa-badge-check",
            "fa-calendar-alt",
            "fa-comment-alt-slash",
            "fa-calendar-star",
            "fa-file-exclamation",
            "fa-shield-alt",
            "fa-location",
            "fa-battery-three-quarters",
            "fa-toggle-on",
            "fa-cart-plus",
            "fa-plus-hexagon",
            "fa-calendar-minus",
            "fa-door-closed",
            "fa-sign-in",
            "fa-compass-slash",
            "fa-bells",
            "fa-comment-alt",
            "fa-calendar-plus",
            "fa-exclamation",
            "fa-lock-alt",
            "fa-file",
            "fa-compass",
            "fa-volume-down",
            "fa-signal-alt-slash",
            "fa-file-check",
            "fa-battery-quarter",
            "fa-minus-hexagon",
            "fa-calendar",
            "fa-user",
            "fa-shopping-cart",
            "fa-signal-alt-1",
            "fa-thermometer-quarter",
            "fa-star",
            "fa-lock-open",
            "fa-tint",
            "fa-signal-4",
            "fa-shield",
            "fa-smoking-ban",
            "fa-battery-slash",
            "fa-user-alt-slash",
            "fa-unlock-alt",
            "fa-eye",
            "fa-folder-open",
            "fa-cart-arrow-down",
            "fa-thermometer-half",
            "fa-minus-octagon",
            "fa-ban",
            "fa-battery-full",
            "fa-info-square",
            "fa-file-plus",
            "fa-calendar-edit",
            "fa-file-edit",
            "fa-gas-pump",
            "fa-wifi-slash",
            "fa-map-marker-slash",
            "fa-wifi-1",
            "fa-signal-alt",
            "fa-toggle-off",
            "fa-file-alt",
            "fa-minus-circle",
            "fa-unlock",
            "fa-sign-out",
            "fa-calendar-times",
            "fa-signal-alt-3",
            "fa-lightbulb",
            "fa-sign-in-alt",
            "fa-phone",
            "fa-parking-slash",
            "fa-map-marker",
            "fa-minus",
            "fa-lightbulb-slash",
            "fa-battery-empty",
            "fa-calendar-day",
            "fa-exclamation-circle",
            "fa-eye-slash",
            "fa-info-circle",
            "fa-battery-half",
            "fa-thermometer-three-quarters",
            "fa-battery-bolt",
            "fa-parking-circle-slash",
            "fa-bell-slash",
            "fa-comment",
            "fa-badge",
            "fa-signal-3",
            "fa-question",
            "fa-phone-slash"
        ]
    },
    {
        "label": "spring",
        "icons": [
            "fa-thunderstorm",
            "fa-allergies",
            "fa-raindrops",
            "fa-cloud-rainbow",
            "fa-rabbit-fast",
            "fa-flower-tulip",
            "fa-seedling",
            "fa-flower",
            "fa-shovel",
            "fa-cloud-sun-rain",
            "fa-frog",
            "fa-rainbow",
            "fa-umbrella",
            "fa-rabbit",
            "fa-cloud-sun",
            "fa-tree-alt",
            "fa-hand-holding-seedling",
            "fa-flower-daffodil",
            "fa-broom",
            "fa-sunglasses"
        ]
    },
    {
        "label": "sports",
        "icons": [
            "fa-dumbbell",
            "fa-skating",
            "fa-basketball-hoop",
            "fa-skiing-nordic",
            "fa-curling",
            "fa-hockey-puck",
            "fa-football-helmet",
            "fa-cricket",
            "fa-bowling-pins",
            "fa-baseball-ball",
            "fa-skiing",
            "fa-swimmer",
            "fa-pennant",
            "fa-boxing-glove",
            "fa-volleyball-ball",
            "fa-ice-skate",
            "fa-baseball",
            "fa-golf-club",
            "fa-golf-ball",
            "fa-hockey-mask",
            "fa-racquet",
            "fa-quidditch",
            "fa-snowboarding",
            "fa-football-ball",
            "fa-whistle",
            "fa-basketball-ball",
            "fa-ski-jump",
            "fa-futbol",
            "fa-sledding",
            "fa-luchador",
            "fa-hockey-sticks",
            "fa-bowling-ball",
            "fa-tennis-ball",
            "fa-biking",
            "fa-biking-mountain",
            "fa-table-tennis",
            "fa-field-hockey",
            "fa-shuttlecock",
            "fa-running"
        ]
    },
    {
        "label": "spinners",
        "icons": [
            "fa-bullseye-arrow",
            "fa-tire-rugged",
            "fa-dharmachakra",
            "fa-compact-disc",
            "fa-wreath",
            "fa-sync-alt",
            "fa-stroopwafel",
            "fa-tire",
            "fa-star-christmas",
            "fa-asterisk",
            "fa-palette",
            "fa-hurricane",
            "fa-slash",
            "fa-spinner-third",
            "fa-sync",
            "fa-atom",
            "fa-eclipse-alt",
            "fa-compass",
            "fa-spinner",
            "fa-yin-yang",
            "fa-circle-notch",
            "fa-atom-alt",
            "fa-sun",
            "fa-crosshairs",
            "fa-cog",
            "fa-certificate",
            "fa-bahai",
            "fa-snowflake",
            "fa-fan",
            "fa-life-ring",
            "fa-spider-web",
            "fa-ring",
            "fa-steering-wheel",
            "fa-badge"
        ]
    },
    {
        "label": "social",
        "icons": [
            "fa-retweet-alt",
            "fa-icons-alt",
            "fa-thumbs-down",
            "fa-map-marker-alt",
            "fa-bell",
            "fa-icons",
            "fa-birthday-cake",
            "fa-video",
            "fa-envelope",
            "fa-user-plus",
            "fa-thumbs-up",
            "fa-signal-stream",
            "fa-images",
            "fa-user-friends",
            "fa-retweet",
            "fa-poll-h",
            "fa-sparkles",
            "fa-thumbtack",
            "fa-hashtag",
            "fa-user-circle",
            "fa-heart",
            "fa-comment-alt",
            "fa-bags-shopping",
            "fa-poll",
            "fa-user",
            "fa-star",
            "fa-photo-video",
            "fa-image",
            "fa-camera",
            "fa-user-crown",
            "fa-map-marker",
            "fa-share-square",
            "fa-users-crown",
            "fa-share",
            "fa-comment",
            "fa-users",
            "fa-share-alt"
        ]
    },
    {
        "label": "shopping",
        "icons": [
            "fa-shipping-fast",
            "fa-shopping-basket",
            "fa-shopping-bag",
            "fa-store-alt-slash",
            "fa-store-slash",
            "fa-store-alt",
            "fa-truck",
            "fa-badge-dollar",
            "fa-badge-check",
            "fa-gift-card",
            "fa-tshirt",
            "fa-shipping-timed",
            "fa-cart-plus",
            "fa-bags-shopping",
            "fa-cash-register",
            "fa-barcode-alt",
            "fa-shopping-cart",
            "fa-box-full",
            "fa-gift",
            "fa-barcode-read",
            "fa-cart-arrow-down",
            "fa-barcode-scan",
            "fa-receipt",
            "fa-booth-curtain",
            "fa-truck-container",
            "fa-person-booth",
            "fa-badge-percent",
            "fa-gifts",
            "fa-store",
            "fa-hand-holding-box",
            "fa-badge",
            "fa-barcode"
        ]
    },
    {
        "label": "shapes",
        "icons": [
            "fa-club",
            "fa-play",
            "fa-square",
            "fa-rectangle-portrait",
            "fa-folder",
            "fa-heart-broken",
            "fa-hexagon",
            "fa-rectangle-wide",
            "fa-heart",
            "fa-file",
            "fa-shapes",
            "fa-octagon",
            "fa-calendar",
            "fa-triangle",
            "fa-star",
            "fa-shield",
            "fa-ticket",
            "fa-certificate",
            "fa-diamond",
            "fa-cloud",
            "fa-spade",
            "fa-map-marker",
            "fa-rectangle-landscape",
            "fa-comment",
            "fa-bookmark",
            "fa-badge",
            "fa-circle"
        ]
    },
    {
        "label": "security",
        "icons": [
            "fa-key-skeleton",
            "fa-lock",
            "fa-mask",
            "fa-file-certificate",
            "fa-door-open",
            "fa-id-card-alt",
            "fa-id-card",
            "fa-lock-open-alt",
            "fa-user-shield",
            "fa-shield-check",
            "fa-user-lock",
            "fa-debug",
            "fa-cctv",
            "fa-file-signature",
            "fa-fingerprint",
            "fa-shield-alt",
            "fa-do-not-enter",
            "fa-siren-on",
            "fa-door-closed",
            "fa-file-contract",
            "fa-user-unlock",
            "fa-lock-alt",
            "fa-whistle",
            "fa-id-badge",
            "fa-lock-open",
            "fa-shield",
            "fa-siren",
            "fa-unlock-alt",
            "fa-eye",
            "fa-bug",
            "fa-ban",
            "fa-passport",
            "fa-key",
            "fa-unlock",
            "fa-usb-drive",
            "fa-eye-slash",
            "fa-dungeon",
            "fa-user-secret",
            "fa-badge-sheriff"
        ]
    },
    {
        "label": "science-fiction",
        "icons": [
            "fa-moon",
            "fa-drone",
            "fa-galaxy",
            "fa-planet-moon",
            "fa-swords-laser",
            "fa-user-alien",
            "fa-watch-calculator",
            "fa-comet",
            "fa-starfighter-alt",
            "fa-portal-exit",
            "fa-stars",
            "fa-space-station-moon-alt",
            "fa-starship-freighter",
            "fa-police-box",
            "fa-radar",
            "fa-moon-stars",
            "fa-transporter-3",
            "fa-satellite",
            "fa-satellite-dish",
            "fa-journal-whills",
            "fa-star-shooting",
            "fa-globe",
            "fa-sword-laser-alt",
            "fa-rocket",
            "fa-user-astronaut",
            "fa-user-robot",
            "fa-portal-enter",
            "fa-hand-spock",
            "fa-meteor",
            "fa-atom",
            "fa-starfighter",
            "fa-jedi-order",
            "fa-telescope",
            "fa-eclipse-alt",
            "fa-starship",
            "fa-transporter-empty",
            "fa-raygun",
            "fa-transporter-1",
            "fa-drone-alt",
            "fa-ufo",
            "fa-transporter-2",
            "fa-atom-alt",
            "fa-planet-ringed",
            "fa-jedi",
            "fa-robot",
            "fa-alien-monster",
            "fa-galactic-senate",
            "fa-transporter",
            "fa-solar-system",
            "fa-eclipse",
            "fa-user-visor",
            "fa-rocket-launch",
            "fa-galactic-republic",
            "fa-ufo-beam",
            "fa-alien",
            "fa-space-station-moon",
            "fa-sword-laser",
            "fa-old-republic",
            "fa-flux-capacitor",
            "fa-cat-space",
            "fa-space-shuttle"
        ]
    },
    {
        "label": "science",
        "icons": [
            "fa-dna",
            "fa-key-skeleton",
            "fa-temperature-low",
            "fa-kite",
            "fa-fire-alt",
            "fa-chart-scatter",
            "fa-seedling",
            "fa-eye-dropper",
            "fa-filter",
            "fa-radiation-alt",
            "fa-capsules",
            "fa-head-side-brain",
            "fa-flask-potion",
            "fa-pills",
            "fa-cauldron",
            "fa-flask",
            "fa-atom",
            "fa-frog",
            "fa-syringe",
            "fa-disease",
            "fa-microscope",
            "fa-tablets",
            "fa-clipboard-check",
            "fa-prescription-bottle",
            "fa-fire",
            "fa-atom-alt",
            "fa-tally",
            "fa-flask-poison",
            "fa-biohazard",
            "fa-analytics",
            "fa-chart-network",
            "fa-temperature-high",
            "fa-mortar-pestle",
            "fa-book-spells",
            "fa-magnet",
            "fa-vials",
            "fa-skull-crossbones",
            "fa-burn",
            "fa-radiation",
            "fa-vial",
            "fa-brain"
        ]
    },
    {
        "label": "religion",
        "icons": [
            "fa-church",
            "fa-hanukiah",
            "fa-dharmachakra",
            "fa-quran",
            "fa-hamsa",
            "fa-gopuram",
            "fa-tanakh",
            "fa-journal-whills",
            "fa-pray",
            "fa-mosque",
            "fa-torah",
            "fa-star-of-david",
            "fa-khanda",
            "fa-bible",
            "fa-atom",
            "fa-ankh",
            "fa-peace",
            "fa-vihara",
            "fa-yin-yang",
            "fa-cross",
            "fa-jedi",
            "fa-place-of-worship",
            "fa-torii-gate",
            "fa-pastafarianism",
            "fa-bahai",
            "fa-kaaba",
            "fa-star-and-crescent",
            "fa-menorah",
            "fa-praying-hands",
            "fa-synagogue",
            "fa-om",
            "fa-dove"
        ]
    },
    {
        "label": "political",
        "icons": [
            "fa-podium",
            "fa-fist-raised",
            "fa-donate",
            "fa-vote-nay",
            "fa-democrat",
            "fa-podium-star",
            "fa-award",
            "fa-vote-yea",
            "fa-ballot-check",
            "fa-calendar-star",
            "fa-balance-scale",
            "fa-box-ballot",
            "fa-landmark-alt",
            "fa-handshake",
            "fa-balance-scale-left",
            "fa-tally",
            "fa-check-double",
            "fa-bullhorn",
            "fa-poll-people",
            "fa-republican",
            "fa-person-sign",
            "fa-ballot",
            "fa-piggy-bank",
            "fa-booth-curtain",
            "fa-balance-scale-right",
            "fa-person-booth",
            "fa-clipboard-list-check",
            "fa-flag-usa",
            "fa-flag-alt",
            "fa-dove"
        ]
    },
    {
        "label": "pharmacy",
        "icons": [
            "fa-history",
            "fa-thermometer",
            "fa-inhaler",
            "fa-eye-dropper",
            "fa-capsules",
            "fa-files-medical",
            "fa-notes-medical",
            "fa-file-medical",
            "fa-flask-potion",
            "fa-book-medical",
            "fa-pills",
            "fa-band-aid",
            "fa-cauldron",
            "fa-flask",
            "fa-syringe",
            "fa-disease",
            "fa-tablets",
            "fa-prescription-bottle",
            "fa-file-prescription",
            "fa-prescription-bottle-alt",
            "fa-cannabis",
            "fa-mortar-pestle",
            "fa-clinic-medical",
            "fa-receipt",
            "fa-vials",
            "fa-laptop-medical",
            "fa-clipboard-prescription",
            "fa-skull-crossbones",
            "fa-prescription",
            "fa-joint",
            "fa-vial",
            "fa-first-aid"
        ]
    },
    {
        "label": "payments-shopping",
        "icons": [
            "fa-ethereum",
            "fa-money-check-alt",
            "fa-tags",
            "fa-alipay",
            "fa-credit-card-blank",
            "fa-btc",
            "fa-cc-amazon-pay",
            "fa-star-exclamation",
            "fa-thumbs-down",
            "fa-shopping-basket",
            "fa-camera-retro",
            "fa-money-check-edit-alt",
            "fa-shopping-bag",
            "fa-cc-apple-pay",
            "fa-bell",
            "fa-credit-card",
            "fa-cc-diners-club",
            "fa-camera-alt",
            "fa-amazon-pay",
            "fa-thumbs-up",
            "fa-trophy",
            "fa-badge-check",
            "fa-paypal",
            "fa-apple-pay",
            "fa-cc-jcb",
            "fa-tag",
            "fa-google-wallet",
            "fa-cc-mastercard",
            "fa-cart-plus",
            "fa-heart",
            "fa-cc-discover",
            "fa-bags-shopping",
            "fa-gem",
            "fa-handshake",
            "fa-stripe-s",
            "fa-shopping-cart",
            "fa-star",
            "fa-bullhorn",
            "fa-gift",
            "fa-bitcoin",
            "fa-cc-paypal",
            "fa-cart-arrow-down",
            "fa-certificate",
            "fa-receipt",
            "fa-cc-visa",
            "fa-key",
            "fa-cc-amex",
            "fa-money-check",
            "fa-camera",
            "fa-cc-stripe",
            "fa-money-check-edit",
            "fa-stripe",
            "fa-trophy-alt",
            "fa-credit-card-front",
            "fa-bookmark",
            "fa-badge"
        ]
    },
    {
        "label": "objects",
        "icons": [
            "fa-bicycle",
            "fa-church",
            "fa-moon",
            "fa-map-signs",
            "fa-money-check-alt",
            "fa-feather",
            "fa-pencil-alt",
            "fa-tags",
            "fa-holly-berry",
            "fa-map",
            "fa-tv",
            "fa-wheelchair",
            "fa-tree",
            "fa-dice-two",
            "fa-paint-brush",
            "fa-phone-alt",
            "fa-calculator",
            "fa-tools",
            "fa-sd-card",
            "fa-toilet",
            "fa-tablet",
            "fa-dice-d6",
            "fa-shopping-basket",
            "fa-camera-retro",
            "fa-hat-wizard",
            "fa-microphone-alt",
            "fa-alarm-clock",
            "fa-dice-one",
            "fa-lock",
            "fa-scroll",
            "fa-glass-whiskey",
            "fa-ornament",
            "fa-wreath",
            "fa-mobile",
            "fa-helmet-battle",
            "fa-newspaper",
            "fa-fireplace",
            "fa-axe-battle",
            "fa-shopping-bag",
            "fa-dice",
            "fa-door-open",
            "fa-suitcase",
            "fa-marker",
            "fa-microphone",
            "fa-sticky-note",
            "fa-map-marker-alt",
            "fa-car",
            "fa-bell",
            "fa-ball-pile",
            "fa-truck-plow",
            "fa-binoculars",
            "fa-paw",
            "fa-glass-champagne",
            "fa-industry",
            "fa-anchor",
            "fa-blender",
            "fa-bath",
            "fa-birthday-cake",
            "fa-lock-open-alt",
            "fa-pen-nib",
            "fa-helicopter",
            "fa-camera-alt",
            "fa-chimney",
            "fa-save",
            "fa-envelope",
            "fa-plane-alt",
            "fa-highlighter",
            "fa-graduation-cap",
            "fa-hospital",
            "fa-headset",
            "fa-paste",
            "fa-print",
            "fa-pencil",
            "fa-ruler-vertical",
            "fa-award",
            "fa-glass-martini",
            "fa-stroopwafel",
            "fa-scroll-old",
            "fa-cubes",
            "fa-motorcycle",
            "fa-film-alt",
            "fa-satellite",
            "fa-tree-decorated",
            "fa-book-dead",
            "fa-hdd",
            "fa-truck",
            "fa-images",
            "fa-money-bill",
            "fa-lemon",
            "fa-satellite-dish",
            "fa-coffee",
            "fa-hammer-war",
            "fa-trophy",
            "fa-road",
            "fa-subway",
            "fa-ice-skate",
            "fa-rv",
            "fa-heart-broken",
            "fa-gamepad",
            "fa-fire-alt",
            "fa-globe",
            "fa-snowmobile",
            "fa-plane",
            "fa-fighter-jet",
            "fa-rocket",
            "fa-calendar-alt",
            "fa-eraser",
            "fa-thumbtack",
            "fa-utensil-knife",
            "fa-snowplow",
            "fa-eye-dropper",
            "fa-gingerbread-man",
            "fa-dice-five",
            "fa-book",
            "fa-tv-retro",
            "fa-ambulance",
            "fa-shield-alt",
            "fa-tag",
            "fa-drum",
            "fa-utensils-alt",
            "fa-dreidel",
            "fa-flask-potion",
            "fa-laptop",
            "fa-dice-d20",
            "fa-scarf",
            "fa-mace",
            "fa-home",
            "fa-cookie-bite",
            "fa-heart",
            "fa-watch",
            "fa-dagger",
            "fa-balance-scale",
            "fa-door-closed",
            "fa-mobile-alt",
            "fa-carrot",
            "fa-flask",
            "fa-sword",
            "fa-cube",
            "fa-sleigh",
            "fa-bells",
            "fa-train",
            "fa-feather-alt",
            "fa-copy",
            "fa-tachometer",
            "fa-fire-extinguisher",
            "fa-dice-d8",
            "fa-flag",
            "fa-bullseye",
            "fa-utensils",
            "fa-utensil-spoon",
            "fa-briefcase",
            "fa-boot",
            "fa-screwdriver",
            "fa-leaf",
            "fa-paper-plane",
            "fa-lock-alt",
            "fa-search",
            "fa-file",
            "fa-compass",
            "fa-archive",
            "fa-lights-holiday",
            "fa-gem",
            "fa-microchip",
            "fa-bed",
            "fa-medal",
            "fa-wine-glass",
            "fa-wrench",
            "fa-weight",
            "fa-puzzle-piece",
            "fa-stocking",
            "fa-plug",
            "fa-industry-alt",
            "fa-tree-large",
            "fa-headphones",
            "fa-calendar",
            "fa-balance-scale-left",
            "fa-tree-christmas",
            "fa-toolbox",
            "fa-shopping-cart",
            "fa-trash-alt",
            "fa-hourglass",
            "fa-shield-cross",
            "fa-star",
            "fa-lock-open",
            "fa-fire",
            "fa-file-prescription",
            "fa-headphones-alt",
            "fa-shield",
            "fa-sim-card",
            "fa-bomb",
            "fa-sun",
            "fa-flag-checkered",
            "fa-paperclip",
            "fa-hat-winter",
            "fa-map-pin",
            "fa-glass-whiskey-rocks",
            "fa-futbol",
            "fa-bullhorn",
            "fa-gift",
            "fa-umbrella",
            "fa-wand-magic",
            "fa-ticket",
            "fa-film",
            "fa-tablet-android",
            "fa-school",
            "fa-dice-three",
            "fa-unlock-alt",
            "fa-ruler-horizontal",
            "fa-pen-alt",
            "fa-mug-hot",
            "fa-ear-muffs",
            "fa-baby-carriage",
            "fa-hat-santa",
            "fa-trash",
            "fa-beer",
            "fa-eye",
            "fa-dice-six",
            "fa-cog",
            "fa-treasure-chest",
            "fa-cogs",
            "fa-bug",
            "fa-clipboard",
            "fa-globe-snow",
            "fa-mobile-android-alt",
            "fa-memory",
            "fa-dice-d12",
            "fa-dice-four",
            "fa-book-spells",
            "fa-mitten",
            "fa-medkit",
            "fa-utensil-fork",
            "fa-tram",
            "fa-fax",
            "fa-snowflake",
            "fa-magnet",
            "fa-dice-d10",
            "fa-igloo",
            "fa-gavel",
            "fa-life-ring",
            "fa-key",
            "fa-stopwatch",
            "fa-envelope-open",
            "fa-keyboard",
            "fa-cloud",
            "fa-file-alt",
            "fa-guitar",
            "fa-money-check",
            "fa-jack-o-lantern",
            "fa-image",
            "fa-camera",
            "fa-ruler-combined",
            "fa-balance-scale-right",
            "fa-unlock",
            "fa-tablet-android-alt",
            "fa-mandolin",
            "fa-bow-arrow",
            "fa-swords",
            "fa-taxi",
            "fa-mobile-android",
            "fa-staff",
            "fa-lightbulb",
            "fa-skull-crossbones",
            "fa-phone",
            "fa-pen-fancy",
            "fa-glass-cheers",
            "fa-magic",
            "fa-map-marker",
            "fa-wand",
            "fa-shower",
            "fa-broadcast-tower",
            "fa-building",
            "fa-shovel-snow",
            "fa-gifts",
            "fa-wallet",
            "fa-cut",
            "fa-ring",
            "fa-bus",
            "fa-candy-cane",
            "fa-university",
            "fa-tree-alt",
            "fa-dice-d4",
            "fa-trophy-alt",
            "fa-tachometer-alt",
            "fa-digital-tachograph",
            "fa-glasses",
            "fa-scythe",
            "fa-bookmark",
            "fa-ticket-alt",
            "fa-space-shuttle",
            "fa-mug-marshmallows",
            "fa-cookie",
            "fa-pen",
            "fa-money-bill-alt",
            "fa-hood-cloak",
            "fa-drum-steelpan",
            "fa-tablet-alt"
        ]
    },
    {
        "label": "music",
        "icons": [
            "fa-play",
            "fa-piano",
            "fa-amp-guitar",
            "fa-volume-mute",
            "fa-file-music",
            "fa-sliders-h",
            "fa-microphone-alt",
            "fa-saxophone",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-microphone-alt-slash",
            "fa-waveform",
            "fa-volume-slash",
            "fa-waveform-path",
            "fa-guitars",
            "fa-user-music",
            "fa-volume-off",
            "fa-comment-music",
            "fa-trumpet",
            "fa-cowbell",
            "fa-list-music",
            "fa-record-vinyl",
            "fa-volume-up",
            "fa-speaker",
            "fa-cloud-music",
            "fa-volume",
            "fa-file-audio",
            "fa-ear",
            "fa-violin",
            "fa-tv-music",
            "fa-microphone-stand",
            "fa-drum",
            "fa-album",
            "fa-computer-speaker",
            "fa-music",
            "fa-cassette-tape",
            "fa-album-collection",
            "fa-bells",
            "fa-radio",
            "fa-sliders-h-square",
            "fa-music-alt-slash",
            "fa-spotify",
            "fa-sliders-v-square",
            "fa-banjo",
            "fa-volume-down",
            "fa-whistle",
            "fa-headphones",
            "fa-cowbell-more",
            "fa-head-side-headphones",
            "fa-gramophone",
            "fa-sax-hot",
            "fa-kazoo",
            "fa-headphones-alt",
            "fa-speakers",
            "fa-music-alt",
            "fa-sliders-v",
            "fa-guitar-electric",
            "fa-clarinet",
            "fa-piano-keyboard",
            "fa-mp3-player",
            "fa-guitar",
            "fa-triangle-music",
            "fa-mandolin",
            "fa-turntable",
            "fa-flute",
            "fa-music-slash",
            "fa-comment-alt-music",
            "fa-radio-alt",
            "fa-soundcloud",
            "fa-drum-steelpan",
            "fa-napster",
            "fa-boombox"
        ]
    },
    {
        "label": "moving",
        "icons": [
            "fa-house-leave",
            "fa-caravan-alt",
            "fa-fragile",
            "fa-suitcase",
            "fa-truck-couch",
            "fa-tape",
            "fa-truck-moving",
            "fa-truck-loading",
            "fa-box-alt",
            "fa-box-up",
            "fa-blanket",
            "fa-loveseat",
            "fa-lamp",
            "fa-person-dolly",
            "fa-dolly",
            "fa-people-carry",
            "fa-archive",
            "fa-boxes-alt",
            "fa-route",
            "fa-wine-glass",
            "fa-caravan",
            "fa-sign",
            "fa-box-full",
            "fa-container-storage",
            "fa-dolly-empty",
            "fa-couch",
            "fa-person-dolly-empty",
            "fa-truck-container",
            "fa-vacuum",
            "fa-truck-ramp",
            "fa-box-fragile",
            "fa-house-return",
            "fa-box-open",
            "fa-ramp-loading",
            "fa-person-carry",
            "fa-trailer"
        ]
    },
    {
        "label": "medical",
        "icons": [
            "fa-clipboard-user",
            "fa-poop",
            "fa-head-side-medical",
            "fa-walker",
            "fa-scalpel-path",
            "fa-monitor-heart-rate",
            "fa-allergies",
            "fa-dna",
            "fa-plus",
            "fa-watch-fitness",
            "fa-thermometer",
            "fa-hand-holding-medical",
            "fa-skeleton",
            "fa-id-card-alt",
            "fa-smoking",
            "fa-head-side-cough",
            "fa-x-ray",
            "fa-lungs",
            "fa-hospitals",
            "fa-hospital",
            "fa-lips",
            "fa-inhaler",
            "fa-heart-rate",
            "fa-hospital-symbol",
            "fa-bacteria",
            "fa-file-medical-alt",
            "fa-tooth",
            "fa-books-medical",
            "fa-head-side-mask",
            "fa-stretcher",
            "fa-ear",
            "fa-user-md-chat",
            "fa-bone-break",
            "fa-virus-slash",
            "fa-radiation-alt",
            "fa-capsules",
            "fa-files-medical",
            "fa-ambulance",
            "fa-notes-medical",
            "fa-comment-medical",
            "fa-head-side-brain",
            "fa-scalpel",
            "fa-file-medical",
            "fa-book-medical",
            "fa-head-side-virus",
            "fa-user-nurse",
            "fa-pills",
            "fa-band-aid",
            "fa-heart",
            "fa-crutch",
            "fa-users-medical",
            "fa-teeth-open",
            "fa-heartbeat",
            "fa-shield-virus",
            "fa-weight",
            "fa-syringe",
            "fa-disease",
            "fa-microscope",
            "fa-bone",
            "fa-stethoscope",
            "fa-tablets",
            "fa-briefcase-medical",
            "fa-diagnoses",
            "fa-kidneys",
            "fa-teeth",
            "fa-hospital-user",
            "fa-bong",
            "fa-prescription-bottle",
            "fa-file-prescription",
            "fa-hospital-alt",
            "fa-smoking-ban",
            "fa-biohazard",
            "fa-prescription-bottle-alt",
            "fa-cannabis",
            "fa-virus",
            "fa-comment-alt-medical",
            "fa-user-md",
            "fa-stomach",
            "fa-mortar-pestle",
            "fa-procedures",
            "fa-clinic-medical",
            "fa-vials",
            "fa-pump-medical",
            "fa-laptop-medical",
            "fa-head-side-cough-slash",
            "fa-crutches",
            "fa-clipboard-prescription",
            "fa-burn",
            "fa-pager",
            "fa-toothbrush",
            "fa-radiation",
            "fa-viruses",
            "fa-prescription",
            "fa-book-user",
            "fa-joint",
            "fa-bacterium",
            "fa-lungs-virus",
            "fa-vial",
            "fa-star-of-life",
            "fa-brain",
            "fa-first-aid"
        ]
    },
    {
        "label": "mathematics",
        "icons": [
            "fa-intersection",
            "fa-infinity",
            "fa-greater-than-equal",
            "fa-calculator",
            "fa-plus",
            "fa-watch-calculator",
            "fa-empty-set",
            "fa-times",
            "fa-percentage",
            "fa-value-absolute",
            "fa-less-than-equal",
            "fa-square-root-alt",
            "fa-greater-than",
            "fa-wave-square",
            "fa-calculator-alt",
            "fa-wave-triangle",
            "fa-square-root",
            "fa-integral",
            "fa-omega",
            "fa-theta",
            "fa-wave-sine",
            "fa-equals",
            "fa-pi",
            "fa-less-than",
            "fa-sigma",
            "fa-function",
            "fa-not-equal",
            "fa-abacus",
            "fa-divide",
            "fa-tally",
            "fa-lambda",
            "fa-tilde",
            "fa-union",
            "fa-minus",
            "fa-subscript",
            "fa-superscript"
        ]
    },
    {
        "label": "marketing",
        "icons": [
            "fa-bullseye-arrow",
            "fa-mail-bulk",
            "fa-megaphone",
            "fa-lightbulb-exclamation",
            "fa-signal-stream",
            "fa-badge-dollar",
            "fa-badge-check",
            "fa-poll-h",
            "fa-sparkles",
            "fa-envelope-open-text",
            "fa-gift-card",
            "fa-lightbulb-on",
            "fa-funnel-dollar",
            "fa-comments-dollar",
            "fa-bullseye",
            "fa-comment-dollar",
            "fa-bullseye-pointer",
            "fa-poll",
            "fa-bullhorn",
            "fa-analytics",
            "fa-comments-alt-dollar",
            "fa-search-dollar",
            "fa-ad",
            "fa-comment-alt-dollar",
            "fa-badge-percent",
            "fa-user-crown",
            "fa-lightbulb",
            "fa-search-location",
            "fa-envelope-open-dollar",
            "fa-lightbulb-slash",
            "fa-lightbulb-dollar",
            "fa-users-crown",
            "fa-badge"
        ]
    },
    {
        "label": "maritime",
        "icons": [
            "fa-wind-warning",
            "fa-dharmachakra",
            "fa-binoculars",
            "fa-anchor",
            "fa-stars",
            "fa-duck",
            "fa-raindrops",
            "fa-swimmer",
            "fa-island-tropical",
            "fa-water-lower",
            "fa-ship",
            "fa-compass-slash",
            "fa-frog",
            "fa-compass",
            "fa-container-storage",
            "fa-treasure-chest",
            "fa-turtle",
            "fa-water-rise",
            "fa-wind",
            "fa-water",
            "fa-walkie-talkie",
            "fa-skull-crossbones",
            "fa-whale"
        ]
    },
    {
        "label": "maps",
        "icons": [
            "fa-bicycle",
            "fa-restroom",
            "fa-map-signs",
            "fa-location-circle",
            "fa-traffic-cone",
            "fa-phone-volume",
            "fa-parking-circle",
            "fa-map-marker-plus",
            "fa-tags",
            "fa-map",
            "fa-phone-square",
            "fa-wheelchair",
            "fa-tty",
            "fa-tree",
            "fa-phone-alt",
            "fa-street-view",
            "fa-plus",
            "fa-shopping-basket",
            "fa-parking",
            "fa-newspaper",
            "fa-draw-polygon",
            "fa-blind",
            "fa-info",
            "fa-shopping-bag",
            "fa-recycle",
            "fa-suitcase",
            "fa-map-marker-alt",
            "fa-car",
            "fa-bell",
            "fa-truck-plow",
            "fa-binoculars",
            "fa-paw",
            "fa-industry",
            "fa-anchor",
            "fa-phone-square-alt",
            "fa-bath",
            "fa-birthday-cake",
            "fa-helicopter",
            "fa-map-marker-times",
            "fa-plane-alt",
            "fa-landmark",
            "fa-graduation-cap",
            "fa-hospital",
            "fa-print",
            "fa-low-vision",
            "fa-glass-martini",
            "fa-traffic-light-stop",
            "fa-cctv",
            "fa-dollar-sign",
            "fa-motorcycle",
            "fa-plus-square",
            "fa-truck",
            "fa-map-marker-edit",
            "fa-images",
            "fa-money-bill",
            "fa-location-slash",
            "fa-lemon",
            "fa-coffee",
            "fa-wifi",
            "fa-trophy",
            "fa-road",
            "fa-map-marker-alt-slash",
            "fa-subway",
            "fa-gamepad",
            "fa-fire-alt",
            "fa-globe",
            "fa-plane",
            "fa-fighter-jet",
            "fa-rocket",
            "fa-thumbtack",
            "fa-utensil-knife",
            "fa-snowplow",
            "fa-traffic-light",
            "fa-book",
            "fa-ambulance",
            "fa-layer-group",
            "fa-tag",
            "fa-map-marker-question",
            "fa-do-not-enter",
            "fa-location",
            "fa-utensils-alt",
            "fa-usd-circle",
            "fa-shoe-prints",
            "fa-home",
            "fa-heart",
            "fa-balance-scale",
            "fa-music",
            "fa-directions",
            "fa-flask",
            "fa-ship",
            "fa-compass-slash",
            "fa-train",
            "fa-fire-extinguisher",
            "fa-flag",
            "fa-utensils",
            "fa-utensil-spoon",
            "fa-location-arrow",
            "fa-skull-cow",
            "fa-briefcase",
            "fa-draw-circle",
            "fa-leaf",
            "fa-search",
            "fa-bags-shopping",
            "fa-route",
            "fa-bed",
            "fa-heartbeat",
            "fa-route-interstate",
            "fa-wine-glass",
            "fa-traffic-light-slow",
            "fa-wrench",
            "fa-map-marker-exclamation",
            "fa-plug",
            "fa-industry-alt",
            "fa-balance-scale-left",
            "fa-map-marker-smile",
            "fa-shopping-cart",
            "fa-fire",
            "fa-tint",
            "fa-bomb",
            "fa-crosshairs",
            "fa-flag-checkered",
            "fa-map-pin",
            "fa-gift",
            "fa-umbrella",
            "fa-ticket",
            "fa-usd-square",
            "fa-map-marker-check",
            "fa-beer",
            "fa-eye",
            "fa-info-square",
            "fa-medkit",
            "fa-utensil-fork",
            "fa-tram",
            "fa-layer-plus",
            "fa-magnet",
            "fa-gavel",
            "fa-map-marker-slash",
            "fa-life-ring",
            "fa-key",
            "fa-traffic-light-go",
            "fa-male",
            "fa-search-plus",
            "fa-image",
            "fa-balance-scale-right",
            "fa-layer-minus",
            "fa-taxi",
            "fa-draw-square",
            "fa-lightbulb",
            "fa-phone",
            "fa-parking-slash",
            "fa-map-marker",
            "fa-shower",
            "fa-h-square",
            "fa-building",
            "fa-search-minus",
            "fa-university",
            "fa-eye-slash",
            "fa-tree-alt",
            "fa-info-circle",
            "fa-trophy-alt",
            "fa-map-marker-minus",
            "fa-parking-circle-slash",
            "fa-bell-slash",
            "fa-route-highway",
            "fa-bookmark",
            "fa-ticket-alt",
            "fa-money-bill-alt"
        ]
    },
    {
        "label": "logistics",
        "icons": [
            "fa-box-check",
            "fa-pallet",
            "fa-shipping-fast",
            "fa-dolly-flatbed-alt",
            "fa-box",
            "fa-scanner-keyboard",
            "fa-warehouse",
            "fa-truck",
            "fa-pallet-alt",
            "fa-hard-hat",
            "fa-user-hard-hat",
            "fa-dolly-flatbed",
            "fa-forklift",
            "fa-dolly",
            "fa-shipping-timed",
            "fa-inventory",
            "fa-hand-receiving",
            "fa-barcode-alt",
            "fa-clipboard-check",
            "fa-conveyor-belt-alt",
            "fa-conveyor-belt",
            "fa-boxes",
            "fa-dolly-flatbed-empty",
            "fa-barcode-read",
            "fa-dolly-empty",
            "fa-barcode-scan",
            "fa-warehouse-alt",
            "fa-clipboard-list",
            "fa-scanner-touchscreen",
            "fa-hand-holding-box",
            "fa-tablet-rugged",
            "fa-scanner"
        ]
    },
    {
        "label": "interfaces",
        "icons": [
            "fa-rss",
            "fa-history",
            "fa-exclamation-triangle",
            "fa-grip-horizontal",
            "fa-pencil-alt",
            "fa-grip-lines-vertical",
            "fa-volume-mute",
            "fa-sort-numeric-down-alt",
            "fa-cloud-upload-alt",
            "fa-undo-alt",
            "fa-star-exclamation",
            "fa-frown",
            "fa-calculator",
            "fa-tools",
            "fa-plus",
            "fa-thumbs-down",
            "fa-sliders-h",
            "fa-question-circle",
            "fa-redo-alt",
            "fa-sort-numeric-up-alt",
            "fa-microphone-alt",
            "fa-alarm-clock",
            "fa-star-half",
            "fa-qrcode",
            "fa-times",
            "fa-signal-alt-2",
            "fa-sort-alpha-up",
            "fa-signal",
            "fa-sign-out-alt",
            "fa-info",
            "fa-exclamation-square",
            "fa-sync-alt",
            "fa-marker",
            "fa-sort-numeric-up",
            "fa-user-alt",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-bell",
            "fa-plus-octagon",
            "fa-calendar-exclamation",
            "fa-check-circle",
            "fa-ellipsis-v-alt",
            "fa-trash-restore-alt",
            "fa-save",
            "fa-envelope",
            "fa-volume-slash",
            "fa-meh",
            "fa-calendar-check",
            "fa-paste",
            "fa-pencil",
            "fa-question-square",
            "fa-language",
            "fa-signal-1",
            "fa-plus-circle",
            "fa-award",
            "fa-sort-amount-down",
            "fa-volume-off",
            "fa-signal-2",
            "fa-minus-square",
            "fa-thumbs-up",
            "fa-reply-all",
            "fa-download",
            "fa-plus-square",
            "fa-cloud-download-alt",
            "fa-volume-up",
            "fa-folder",
            "fa-coffee",
            "fa-wifi-2",
            "fa-wifi",
            "fa-signal-slash",
            "fa-trophy",
            "fa-volume",
            "fa-badge-check",
            "fa-file-download",
            "fa-lasso",
            "fa-calendar-alt",
            "fa-eraser",
            "fa-external-link-square",
            "fa-ellipsis-h-alt",
            "fa-filter",
            "fa-fingerprint",
            "fa-shield-alt",
            "fa-reply",
            "fa-toggle-on",
            "fa-sort",
            "fa-hashtag",
            "fa-file-upload",
            "fa-smile",
            "fa-home",
            "fa-plus-hexagon",
            "fa-user-circle",
            "fa-calendar-minus",
            "fa-heart",
            "fa-sync",
            "fa-times-octagon",
            "fa-sign-in",
            "fa-sort-alt",
            "fa-cloud-upload",
            "fa-copy",
            "fa-quote-right",
            "fa-rss-square",
            "fa-flag",
            "fa-bullseye",
            "fa-calendar-plus",
            "fa-screwdriver",
            "fa-sliders-h-square",
            "fa-exclamation",
            "fa-search",
            "fa-file",
            "fa-sliders-v-square",
            "fa-sort-up",
            "fa-volume-down",
            "fa-medal",
            "fa-wrench",
            "fa-signal-alt-slash",
            "fa-ellipsis-h",
            "fa-minus-hexagon",
            "fa-sort-alpha-up-alt",
            "fa-sitemap",
            "fa-calendar",
            "fa-blog",
            "fa-user",
            "fa-check-square",
            "fa-grip-vertical",
            "fa-trash-undo",
            "fa-edit",
            "fa-signal-alt-1",
            "fa-trash-alt",
            "fa-star",
            "fa-signal-4",
            "fa-shield",
            "fa-check-double",
            "fa-sort-amount-up",
            "fa-check",
            "fa-grip-lines",
            "fa-sort-amount-up-alt",
            "fa-flag-checkered",
            "fa-times-circle",
            "fa-bullhorn",
            "fa-quote-left",
            "fa-undo",
            "fa-external-link-square-alt",
            "fa-sliders-v",
            "fa-pen-alt",
            "fa-trash-undo-alt",
            "fa-file-export",
            "fa-times-hexagon",
            "fa-trash",
            "fa-beer",
            "fa-eye",
            "fa-cog",
            "fa-folder-open",
            "fa-cogs",
            "fa-bug",
            "fa-clipboard",
            "fa-poo",
            "fa-minus-octagon",
            "fa-ban",
            "fa-share-alt-square",
            "fa-certificate",
            "fa-ellipsis-v",
            "fa-info-square",
            "fa-calendar-edit",
            "fa-sort-alpha-down",
            "fa-bars",
            "fa-wifi-slash",
            "fa-upload",
            "fa-wifi-1",
            "fa-signal-alt",
            "fa-envelope-open",
            "fa-toggle-off",
            "fa-cloud",
            "fa-search-plus",
            "fa-file-alt",
            "fa-clone",
            "fa-minus-circle",
            "fa-sign-out",
            "fa-calendar-times",
            "fa-file-search",
            "fa-sort-down",
            "fa-redo",
            "fa-signal-alt-3",
            "fa-sign-in-alt",
            "fa-pen-fancy",
            "fa-magic",
            "fa-sort-alpha-down-alt",
            "fa-times-square",
            "fa-minus",
            "fa-cut",
            "fa-dot-circle",
            "fa-sort-amount-down-alt",
            "fa-search-minus",
            "fa-exclamation-circle",
            "fa-share-square",
            "fa-eye-slash",
            "fa-info-circle",
            "fa-trophy-alt",
            "fa-cloud-download",
            "fa-share",
            "fa-bell-slash",
            "fa-file-import",
            "fa-trash-restore",
            "fa-glasses",
            "fa-share-all",
            "fa-external-link-alt",
            "fa-database",
            "fa-sort-numeric-down",
            "fa-external-link",
            "fa-badge",
            "fa-i-cursor",
            "fa-pen",
            "fa-signal-3",
            "fa-share-alt",
            "fa-circle",
            "fa-question",
            "fa-barcode"
        ]
    },
    {
        "label": "images",
        "icons": [
            "fa-image-polaroid",
            "fa-sliders-h",
            "fa-camera-retro",
            "fa-bolt",
            "fa-expand",
            "fa-id-card",
            "fa-compress",
            "fa-chalkboard",
            "fa-camera-alt",
            "fa-rectangle-portrait",
            "fa-film-alt",
            "fa-expand-wide",
            "fa-images",
            "fa-film-canister",
            "fa-eye-dropper",
            "fa-camera-polaroid",
            "fa-rectangle-wide",
            "fa-file-image",
            "fa-sliders-h-square",
            "fa-sliders-v-square",
            "fa-id-badge",
            "fa-tint",
            "fa-compress-arrows-alt",
            "fa-photo-video",
            "fa-film",
            "fa-sliders-v",
            "fa-compress-wide",
            "fa-eye",
            "fa-adjust",
            "fa-clone",
            "fa-image",
            "fa-camera",
            "fa-rectangle-landscape",
            "fa-eye-slash",
            "fa-portrait"
        ]
    },
    {
        "label": "household",
        "icons": [
            "fa-laptop-house",
            "fa-temperature-down",
            "fa-house-leave",
            "fa-light-switch",
            "fa-tv",
            "fa-lamp-desk",
            "fa-dryer-alt",
            "fa-garage",
            "fa-house",
            "fa-fireplace",
            "fa-door-open",
            "fa-toilet-paper-slash",
            "fa-bell",
            "fa-blender",
            "fa-house-day",
            "fa-bath",
            "fa-flashlight",
            "fa-house-night",
            "fa-outlet",
            "fa-blanket",
            "fa-house-user",
            "fa-cctv",
            "fa-lamp-floor",
            "fa-signal-stream",
            "fa-sprinkler",
            "fa-loveseat",
            "fa-window-frame",
            "fa-coffee",
            "fa-garage-open",
            "fa-mailbox",
            "fa-light-ceiling",
            "fa-speaker",
            "fa-window-frame-open",
            "fa-lamp",
            "fa-sort-circle-up",
            "fa-coffee-pot",
            "fa-bed-alt",
            "fa-toilet-paper-alt",
            "fa-sensor-on",
            "fa-camera-home",
            "fa-bell-on",
            "fa-toilet-paper",
            "fa-blinds-raised",
            "fa-tv-retro",
            "fa-heat",
            "fa-microwave",
            "fa-lightbulb-on",
            "fa-refrigerator",
            "fa-siren-on",
            "fa-oven",
            "fa-books",
            "fa-blinds",
            "fa-air-conditioner",
            "fa-door-closed",
            "fa-sort-circle-down",
            "fa-temperature-up",
            "fa-sensor",
            "fa-bed",
            "fa-plug",
            "fa-washer",
            "fa-soap",
            "fa-faucet",
            "fa-sink",
            "fa-webcam",
            "fa-chair",
            "fa-siren",
            "fa-speakers",
            "fa-faucet-drip",
            "fa-fan-table",
            "fa-sensor-smoke",
            "fa-dryer",
            "fa-snowflake",
            "fa-fan",
            "fa-vacuum-robot",
            "fa-couch",
            "fa-sort-circle",
            "fa-tv-alt",
            "fa-sensor-fire",
            "fa-garage-car",
            "fa-vacuum",
            "fa-bed-empty",
            "fa-box-tissue",
            "fa-lightbulb",
            "fa-house-signal",
            "fa-shower",
            "fa-light-switch-on",
            "fa-light-switch-off",
            "fa-chair-office",
            "fa-house-return",
            "fa-pump-soap",
            "fa-dungeon",
            "fa-sensor-alert",
            "fa-bed-bunk",
            "fa-blinds-open"
        ]
    },
    {
        "label": "hotel",
        "icons": [
            "fa-infinity",
            "fa-cocktail",
            "fa-luggage-cart",
            "fa-dumbbell",
            "fa-tv",
            "fa-wheelchair",
            "fa-lamp-desk",
            "fa-dryer-alt",
            "fa-alarm-clock",
            "fa-fireplace",
            "fa-dice",
            "fa-door-open",
            "fa-suitcase",
            "fa-shuttle-van",
            "fa-swimming-pool",
            "fa-concierge-bell",
            "fa-smoking",
            "fa-glass-martini-alt",
            "fa-car",
            "fa-car-building",
            "fa-bath",
            "fa-suitcase-rolling",
            "fa-alarm-snooze",
            "fa-outlet",
            "fa-car-bus",
            "fa-glass-martini",
            "fa-swimmer",
            "fa-coffee",
            "fa-wifi",
            "fa-spa",
            "fa-umbrella-beach",
            "fa-dice-five",
            "fa-tv-retro",
            "fa-heat",
            "fa-microwave",
            "fa-refrigerator",
            "fa-snooze",
            "fa-utensils-alt",
            "fa-oven",
            "fa-air-conditioner",
            "fa-hot-tub",
            "fa-door-closed",
            "fa-utensils",
            "fa-briefcase",
            "fa-bed",
            "fa-car-garage",
            "fa-washer",
            "fa-smoking-ban",
            "fa-hotel",
            "fa-fan-table",
            "fa-baby-carriage",
            "fa-dryer",
            "fa-snowflake",
            "fa-wifi-slash",
            "fa-key",
            "fa-tv-alt",
            "fa-vacuum",
            "fa-bed-empty",
            "fa-shower",
            "fa-bed-bunk",
            "fa-paw-alt"
        ]
    },
    {
        "label": "holiday",
        "icons": [
            "fa-holly-berry",
            "fa-ornament",
            "fa-wreath",
            "fa-snowman",
            "fa-fireplace",
            "fa-turkey",
            "fa-glass-champagne",
            "fa-tree-decorated",
            "fa-rv",
            "fa-star-christmas",
            "fa-gingerbread-man",
            "fa-dreidel",
            "fa-cookie-bite",
            "fa-carrot",
            "fa-deer-rudolph",
            "fa-sleigh",
            "fa-bells",
            "fa-lights-holiday",
            "fa-stocking",
            "fa-tree-christmas",
            "fa-angel",
            "fa-gift",
            "fa-mug-hot",
            "fa-hat-santa",
            "fa-deer",
            "fa-mistletoe",
            "fa-glass-cheers",
            "fa-gifts",
            "fa-candy-cane",
            "fa-narwhal"
        ]
    },
    {
        "label": "health",
        "icons": [
            "fa-wheelchair",
            "fa-hospital",
            "fa-plus-square",
            "fa-ambulance",
            "fa-heart",
            "fa-heartbeat",
            "fa-stethoscope",
            "fa-accessible-icon",
            "fa-user-md",
            "fa-medkit",
            "fa-h-square",
            "fa-prescription"
        ]
    },
    {
        "label": "hands",
        "icons": [
            "fa-hands-usd",
            "fa-hand-rock",
            "fa-allergies",
            "fa-thumbs-down",
            "fa-fist-raised",
            "fa-hand-holding-medical",
            "fa-hands-wash",
            "fa-hand-scissors",
            "fa-handshake-slash",
            "fa-thumbs-up",
            "fa-handshake-alt",
            "fa-hand-lizard",
            "fa-hand-point-up",
            "fa-hand-holding-magic",
            "fa-hand-pointer",
            "fa-hand-heart",
            "fa-hand-holding",
            "fa-handshake-alt-slash",
            "fa-hand-spock",
            "fa-hands",
            "fa-hand-receiving",
            "fa-handshake",
            "fa-hand-point-left",
            "fa-hand-sparkles",
            "fa-hand-holding-usd",
            "fa-hand-middle-finger",
            "fa-hand-paper",
            "fa-hands-helping",
            "fa-hand-peace",
            "fa-hand-holding-water",
            "fa-hand-holding-heart",
            "fa-hands-heart",
            "fa-praying-hands",
            "fa-hand-point-down",
            "fa-hand-holding-seedling",
            "fa-hand-holding-box",
            "fa-hand-point-right"
        ]
    },
    {
        "label": "halloween",
        "icons": [
            "fa-key-skeleton",
            "fa-spider",
            "fa-hat-wizard",
            "fa-tombstone",
            "fa-mask",
            "fa-tombstone-alt",
            "fa-spider-black-widow",
            "fa-ghost",
            "fa-hat-witch",
            "fa-book-dead",
            "fa-cat",
            "fa-sparkles",
            "fa-knife-kitchen",
            "fa-toilet-paper-alt",
            "fa-toilet-paper",
            "fa-candy-corn",
            "fa-flask-potion",
            "fa-cauldron",
            "fa-scarecrow",
            "fa-coffin",
            "fa-candle-holder",
            "fa-hockey-mask",
            "fa-claw-marks",
            "fa-crow",
            "fa-flask-poison",
            "fa-wand-magic",
            "fa-book-spells",
            "fa-jack-o-lantern",
            "fa-skull-crossbones",
            "fa-wand",
            "fa-spider-web",
            "fa-cloud-moon",
            "fa-bat",
            "fa-scythe",
            "fa-broom"
        ]
    },
    {
        "label": "gender",
        "icons": [
            "fa-venus",
            "fa-mars-stroke",
            "fa-venus-mars",
            "fa-transgender",
            "fa-mars-stroke-h",
            "fa-transgender-alt",
            "fa-mars",
            "fa-venus-double",
            "fa-mars-stroke-v",
            "fa-neuter",
            "fa-mars-double",
            "fa-genderless",
            "fa-mercury"
        ]
    },
    {
        "label": "gaming-tabletop",
        "icons": [
            "fa-fantasy-flight-games",
            "fa-dice-d6",
            "fa-fist-raised",
            "fa-hat-wizard",
            "fa-scroll",
            "fa-helmet-battle",
            "fa-axe-battle",
            "fa-paw-claws",
            "fa-scroll-old",
            "fa-book-dead",
            "fa-critical-role",
            "fa-eye-evil",
            "fa-hammer-war",
            "fa-sparkles",
            "fa-wizards-of-the-coast",
            "fa-hand-holding-magic",
            "fa-flask-potion",
            "fa-dice-d20",
            "fa-mace",
            "fa-game-board",
            "fa-dagger",
            "fa-sword",
            "fa-dice-d8",
            "fa-d-and-d-beyond",
            "fa-game-board-alt",
            "fa-shield-cross",
            "fa-flame",
            "fa-d-and-d",
            "fa-wand-magic",
            "fa-treasure-chest",
            "fa-dice-d12",
            "fa-book-spells",
            "fa-dice-d10",
            "fa-dragon",
            "fa-mandolin",
            "fa-bow-arrow",
            "fa-swords",
            "fa-staff",
            "fa-sickle",
            "fa-skull-crossbones",
            "fa-wand",
            "fa-penny-arcade",
            "fa-ring",
            "fa-acquisitions-incorporated",
            "fa-dice-d4",
            "fa-scythe",
            "fa-dungeon",
            "fa-hood-cloak",
            "fa-campfire"
        ]
    },
    {
        "label": "games",
        "icons": [
            "fa-club",
            "fa-game-console-handheld",
            "fa-dice-two",
            "fa-steam-square",
            "fa-dice-d6",
            "fa-joystick",
            "fa-steam",
            "fa-dice-one",
            "fa-chess",
            "fa-chess-rook",
            "fa-dice",
            "fa-ghost",
            "fa-chess-board",
            "fa-headset",
            "fa-chess-clock-alt",
            "fa-chess-queen-alt",
            "fa-chess-knight",
            "fa-gamepad-alt",
            "fa-steam-symbol",
            "fa-playstation",
            "fa-gamepad",
            "fa-chess-bishop",
            "fa-dice-five",
            "fa-dreidel",
            "fa-chess-pawn",
            "fa-dice-d20",
            "fa-heart",
            "fa-dice-d8",
            "fa-chess-clock",
            "fa-puzzle-piece",
            "fa-chess-king",
            "fa-chess-rook-alt",
            "fa-chess-bishop-alt",
            "fa-dice-three",
            "fa-alien-monster",
            "fa-dice-six",
            "fa-dice-d12",
            "fa-dice-four",
            "fa-dice-d10",
            "fa-chess-knight-alt",
            "fa-diamond",
            "fa-chess-king-alt",
            "fa-spade",
            "fa-chess-pawn-alt",
            "fa-twitch",
            "fa-xbox",
            "fa-dice-d4",
            "fa-chess-queen"
        ]
    },
    {
        "label": "fruit-vegetable",
        "icons": [
            "fa-pepper-hot",
            "fa-lemon",
            "fa-salad",
            "fa-seedling",
            "fa-pumpkin",
            "fa-wheat",
            "fa-carrot",
            "fa-leaf",
            "fa-apple-crate",
            "fa-apple-alt"
        ]
    },
    {
        "label": "food",
        "icons": [
            "fa-pepper-hot",
            "fa-taco",
            "fa-corn",
            "fa-pie",
            "fa-sausage",
            "fa-drumstick",
            "fa-shish-kebab",
            "fa-turkey",
            "fa-hamburger",
            "fa-stroopwafel",
            "fa-egg-fried",
            "fa-french-fries",
            "fa-lemon",
            "fa-salad",
            "fa-seedling",
            "fa-cloud-meatball",
            "fa-pumpkin",
            "fa-gingerbread-man",
            "fa-burrito",
            "fa-candy-corn",
            "fa-soup",
            "fa-bacon",
            "fa-hat-chef",
            "fa-wheat",
            "fa-fish",
            "fa-croissant",
            "fa-carrot",
            "fa-steak",
            "fa-ice-cream",
            "fa-cheese",
            "fa-bone",
            "fa-burger-soda",
            "fa-egg",
            "fa-popcorn",
            "fa-apple-crate",
            "fa-hotdog",
            "fa-apple-alt",
            "fa-cheeseburger",
            "fa-pizza",
            "fa-bread-loaf",
            "fa-candy-cane",
            "fa-fish-cooked",
            "fa-bread-slice",
            "fa-meat",
            "fa-pizza-slice",
            "fa-cheese-swiss",
            "fa-sandwich",
            "fa-cookie",
            "fa-drumstick-bite"
        ]
    },
    {
        "label": "fitness",
        "icons": [
            "fa-bicycle",
            "fa-skating",
            "fa-monitor-heart-rate",
            "fa-skiing-nordic",
            "fa-watch-fitness",
            "fa-hiking",
            "fa-skiing",
            "fa-heart-rate",
            "fa-swimmer",
            "fa-spa",
            "fa-fire-alt",
            "fa-walking",
            "fa-book-heart",
            "fa-shoe-prints",
            "fa-heart",
            "fa-snowboarding",
            "fa-heartbeat",
            "fa-ski-jump",
            "fa-burn",
            "fa-biking",
            "fa-biking-mountain",
            "fa-running"
        ]
    },
    {
        "label": "finance",
        "icons": [
            "fa-money-check-alt",
            "fa-file-chart-line",
            "fa-hands-usd",
            "fa-credit-card-blank",
            "fa-money-bill-wave",
            "fa-donate",
            "fa-chart-pie-alt",
            "fa-coins",
            "fa-chart-line-down",
            "fa-percentage",
            "fa-credit-card",
            "fa-landmark",
            "fa-stamp",
            "fa-sack-dollar",
            "fa-money-bill-wave-alt",
            "fa-badge-dollar",
            "fa-money-bill",
            "fa-sack",
            "fa-book",
            "fa-balance-scale",
            "fa-chart-line",
            "fa-comments-dollar",
            "fa-cash-register",
            "fa-comment-dollar",
            "fa-hand-holding-usd",
            "fa-balance-scale-left",
            "fa-tally",
            "fa-file-invoice-dollar",
            "fa-analytics",
            "fa-comments-alt-dollar",
            "fa-treasure-chest",
            "fa-file-chart-pie",
            "fa-chart-pie",
            "fa-receipt",
            "fa-piggy-bank",
            "fa-money-check",
            "fa-balance-scale-right",
            "fa-comment-alt-dollar",
            "fa-badge-percent",
            "fa-file-invoice",
            "fa-coin",
            "fa-wallet",
            "fa-credit-card-front",
            "fa-money-bill-alt"
        ]
    },
    {
        "label": "files",
        "icons": [
            "fa-file-music",
            "fa-file-excel",
            "fa-file-minus",
            "fa-sticky-note",
            "fa-file-times",
            "fa-file-video",
            "fa-save",
            "fa-paste",
            "fa-folder",
            "fa-file-powerpoint",
            "fa-file-audio",
            "fa-file-word",
            "fa-file-archive",
            "fa-file-exclamation",
            "fa-copy",
            "fa-file-image",
            "fa-file",
            "fa-archive",
            "fa-file-check",
            "fa-photo-video",
            "fa-folder-open",
            "fa-file-plus",
            "fa-file-edit",
            "fa-file-alt",
            "fa-clone",
            "fa-file-search",
            "fa-file-code",
            "fa-cut",
            "fa-file-pdf"
        ]
    },
    {
        "label": "energy",
        "icons": [
            "fa-poop",
            "fa-industry",
            "fa-house-day",
            "fa-house-night",
            "fa-outlet",
            "fa-gas-pump-slash",
            "fa-fire-alt",
            "fa-seedling",
            "fa-burrito",
            "fa-radiation-alt",
            "fa-heat",
            "fa-battery-three-quarters",
            "fa-atom",
            "fa-leaf",
            "fa-battery-quarter",
            "fa-plug",
            "fa-industry-alt",
            "fa-charging-station",
            "fa-fire",
            "fa-atom-alt",
            "fa-power-off",
            "fa-sun",
            "fa-battery-slash",
            "fa-solar-panel",
            "fa-battery-full",
            "fa-gas-pump",
            "fa-wind",
            "fa-fan",
            "fa-water",
            "fa-lightbulb",
            "fa-burn",
            "fa-broadcast-tower",
            "fa-battery-empty",
            "fa-radiation",
            "fa-battery-half",
            "fa-wind-turbine",
            "fa-battery-bolt"
        ]
    },
    {
        "label": "emoji",
        "icons": [
            "fa-grin-tongue-wink",
            "fa-meh-rolling-eyes",
            "fa-frown",
            "fa-grin-hearts",
            "fa-laugh",
            "fa-grin-tongue-squint",
            "fa-sad-tear",
            "fa-grin-wink",
            "fa-meh",
            "fa-flushed",
            "fa-tired",
            "fa-kiss-beam",
            "fa-grin-stars",
            "fa-grin-squint",
            "fa-grin-squint-tears",
            "fa-grin",
            "fa-grin-beam-sweat",
            "fa-surprise",
            "fa-grin-tears",
            "fa-kiss-wink-heart",
            "fa-smile",
            "fa-grimace",
            "fa-smile-beam",
            "fa-frown-open",
            "fa-smile-wink",
            "fa-angry",
            "fa-dizzy",
            "fa-grin-beam",
            "fa-laugh-squint",
            "fa-grin-alt",
            "fa-grin-tongue",
            "fa-sad-cry",
            "fa-kiss",
            "fa-laugh-wink",
            "fa-meh-blank",
            "fa-laugh-beam"
        ]
    },
    {
        "label": "education",
        "icons": [
            "fa-book-reader",
            "fa-theater-masks",
            "fa-globe-stand",
            "fa-backpack",
            "fa-bell-school-slash",
            "fa-file-certificate",
            "fa-bell",
            "fa-chalkboard",
            "fa-graduation-cap",
            "fa-bell-school",
            "fa-award",
            "fa-ruler-triangle",
            "fa-bus-school",
            "fa-books",
            "fa-music",
            "fa-atom",
            "fa-users-class",
            "fa-shapes",
            "fa-microscope",
            "fa-laptop-code",
            "fa-user-graduate",
            "fa-diploma",
            "fa-book-open",
            "fa-atom-alt",
            "fa-school",
            "fa-glasses-alt",
            "fa-apple-alt",
            "fa-book-alt",
            "fa-pencil-paintbrush",
            "fa-chalkboard-teacher",
            "fa-bell-slash"
        ]
    },
    {
        "label": "editors",
        "icons": [
            "fa-list",
            "fa-columns",
            "fa-send-back",
            "fa-pencil-alt",
            "fa-unlink",
            "fa-undo-alt",
            "fa-icons-alt",
            "fa-kerning",
            "fa-link",
            "fa-tools",
            "fa-th",
            "fa-border-top",
            "fa-redo-alt",
            "fa-bring-front",
            "fa-underline",
            "fa-remove-format",
            "fa-align-left",
            "fa-typewriter",
            "fa-sync-alt",
            "fa-marker",
            "fa-align-justify",
            "fa-icons",
            "fa-pen-nib",
            "fa-text-height",
            "fa-trash-restore-alt",
            "fa-border-center-v",
            "fa-highlighter",
            "fa-paste",
            "fa-print",
            "fa-pencil",
            "fa-h3",
            "fa-tasks",
            "fa-strikethrough",
            "fa-reply-all",
            "fa-border-left",
            "fa-th-large",
            "fa-list-ol",
            "fa-page-break",
            "fa-heading",
            "fa-border-inner",
            "fa-bring-forward",
            "fa-border-right",
            "fa-eraser",
            "fa-bold",
            "fa-border-all",
            "fa-overline",
            "fa-border-bottom",
            "fa-reply",
            "fa-outdent",
            "fa-paragraph-rtl",
            "fa-border-style-alt",
            "fa-indent",
            "fa-sync",
            "fa-send-backward",
            "fa-align-right",
            "fa-h1",
            "fa-copy",
            "fa-quote-right",
            "fa-table",
            "fa-screwdriver",
            "fa-paper-plane",
            "fa-file",
            "fa-text-width",
            "fa-font",
            "fa-text",
            "fa-wrench",
            "fa-list-alt",
            "fa-border-outer",
            "fa-horizontal-rule",
            "fa-edit",
            "fa-trash-alt",
            "fa-border-none",
            "fa-paperclip",
            "fa-quote-left",
            "fa-undo",
            "fa-tasks-alt",
            "fa-pen-alt",
            "fa-line-columns",
            "fa-trash",
            "fa-clipboard",
            "fa-italic",
            "fa-h2",
            "fa-text-size",
            "fa-file-alt",
            "fa-clone",
            "fa-paragraph",
            "fa-spell-check",
            "fa-redo",
            "fa-th-list",
            "fa-pen-fancy",
            "fa-cut",
            "fa-h4",
            "fa-border-style",
            "fa-border-center-h",
            "fa-subscript",
            "fa-font-case",
            "fa-align-slash",
            "fa-share",
            "fa-trash-restore",
            "fa-glasses",
            "fa-share-all",
            "fa-list-ul",
            "fa-i-cursor",
            "fa-pen",
            "fa-superscript",
            "fa-align-center"
        ]
    },
    {
        "label": "design",
        "icons": [
            "fa-send-back",
            "fa-pencil-alt",
            "fa-image-polaroid",
            "fa-icons-alt",
            "fa-drafting-compass",
            "fa-pencil-ruler",
            "fa-paint-brush",
            "fa-bring-front",
            "fa-draw-polygon",
            "fa-tint-slash",
            "fa-marker",
            "fa-icons",
            "fa-pen-nib",
            "fa-save",
            "fa-highlighter",
            "fa-paste",
            "fa-pencil",
            "fa-stamp",
            "fa-crop-alt",
            "fa-ruler-vertical",
            "fa-spray-can",
            "fa-fill",
            "fa-fill-drip",
            "fa-scanner-image",
            "fa-lasso",
            "fa-bring-forward",
            "fa-eraser",
            "fa-eye-dropper",
            "fa-paint-brush-alt",
            "fa-layer-group",
            "fa-palette",
            "fa-camera-polaroid",
            "fa-send-backward",
            "fa-crop",
            "fa-object-group",
            "fa-copy",
            "fa-draw-circle",
            "fa-swatchbook",
            "fa-splotch",
            "fa-edit",
            "fa-tint",
            "fa-bezier-curve",
            "fa-crosshairs",
            "fa-ruler-horizontal",
            "fa-pen-alt",
            "fa-vector-square",
            "fa-brush",
            "fa-eye",
            "fa-adjust",
            "fa-layer-plus",
            "fa-object-ungroup",
            "fa-clone",
            "fa-ruler-combined",
            "fa-layer-minus",
            "fa-draw-square",
            "fa-pen-fancy",
            "fa-magic",
            "fa-cut",
            "fa-eye-slash",
            "fa-paint-roller",
            "fa-pen"
        ]
    },
    {
        "label": "date-time",
        "icons": [
            "fa-alarm-plus",
            "fa-hourglass-half",
            "fa-watch-calculator",
            "fa-alarm-clock",
            "fa-alarm-exclamation",
            "fa-bell",
            "fa-hourglass-end",
            "fa-house-day",
            "fa-calendar-exclamation",
            "fa-house-night",
            "fa-hourglass-start",
            "fa-alarm-snooze",
            "fa-calendar-check",
            "fa-calendar-alt",
            "fa-snooze",
            "fa-calendar-minus",
            "fa-watch",
            "fa-calendar-plus",
            "fa-calendar",
            "fa-hourglass",
            "fa-bell-exclamation",
            "fa-bell-plus",
            "fa-calendar-edit",
            "fa-stopwatch",
            "fa-calendar-times",
            "fa-clock",
            "fa-flux-capacitor",
            "fa-bell-slash"
        ]
    },
    {
        "label": "currency",
        "icons": [
            "fa-ethereum",
            "fa-money-check-alt",
            "fa-btc",
            "fa-money-bill-wave",
            "fa-gg",
            "fa-euro-sign",
            "fa-sack-dollar",
            "fa-pound-sign",
            "fa-money-bill-wave-alt",
            "fa-dollar-sign",
            "fa-money-bill",
            "fa-sack",
            "fa-lira-sign",
            "fa-hryvnia",
            "fa-usd-circle",
            "fa-rupee-sign",
            "fa-gg-circle",
            "fa-won-sign",
            "fa-usd-square",
            "fa-shekel-sign",
            "fa-bitcoin",
            "fa-yen-sign",
            "fa-money-check",
            "fa-tenge",
            "fa-coin",
            "fa-ruble-sign",
            "fa-money-bill-alt"
        ]
    },
    {
        "label": "construction",
        "icons": [
            "fa-traffic-cone",
            "fa-digging",
            "fa-pencil-alt",
            "fa-drafting-compass",
            "fa-pencil-ruler",
            "fa-tools",
            "fa-ruler",
            "fa-pencil",
            "fa-ruler-vertical",
            "fa-axe",
            "fa-ruler-triangle",
            "fa-construction",
            "fa-hard-hat",
            "fa-user-hard-hat",
            "fa-forklift",
            "fa-shovel",
            "fa-screwdriver",
            "fa-wrench",
            "fa-dumpster",
            "fa-toolbox",
            "fa-truck-pickup",
            "fa-ruler-horizontal",
            "fa-brush",
            "fa-ruler-combined",
            "fa-truck-container",
            "fa-hammer",
            "fa-paint-roller"
        ]
    },
    {
        "label": "computers",
        "icons": [
            "fa-laptop-house",
            "fa-tv",
            "fa-computer-classic",
            "fa-brackets",
            "fa-sd-card",
            "fa-tablet",
            "fa-watch-calculator",
            "fa-ethernet",
            "fa-mobile",
            "fa-save",
            "fa-print",
            "fa-disc-drive",
            "fa-stream",
            "fa-download",
            "fa-satellite",
            "fa-hdd",
            "fa-server",
            "fa-webcam-slash",
            "fa-satellite-dish",
            "fa-mouse-alt",
            "fa-speaker",
            "fa-scanner-image",
            "fa-tv-music",
            "fa-router",
            "fa-phone-laptop",
            "fa-tv-retro",
            "fa-laptop",
            "fa-computer-speaker",
            "fa-mobile-alt",
            "fa-desktop",
            "fa-microchip",
            "fa-plug",
            "fa-headphones",
            "fa-webcam",
            "fa-brackets-curly",
            "fa-sim-card",
            "fa-speakers",
            "fa-power-off",
            "fa-tablet-android",
            "fa-desktop-alt",
            "fa-mobile-android-alt",
            "fa-memory",
            "fa-upload",
            "fa-mp3-player",
            "fa-keyboard",
            "fa-tablet-android-alt",
            "fa-mobile-android",
            "fa-usb-drive",
            "fa-mouse",
            "fa-database",
            "fa-tablet-alt"
        ]
    },
    {
        "label": "communication",
        "icons": [
            "fa-inbox",
            "fa-rss",
            "fa-phone-volume",
            "fa-phone-square",
            "fa-tty",
            "fa-phone-alt",
            "fa-microphone-alt",
            "fa-mobile",
            "fa-envelope-square",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-bell",
            "fa-phone-square-alt",
            "fa-bluetooth-b",
            "fa-chalkboard",
            "fa-microphone-alt-slash",
            "fa-envelope",
            "fa-inbox-in",
            "fa-language",
            "fa-assistive-listening-systems",
            "fa-signal-stream",
            "fa-at",
            "fa-american-sign-language-interpreting",
            "fa-webcam-slash",
            "fa-wifi",
            "fa-bluetooth",
            "fa-comments",
            "fa-mobile-alt",
            "fa-address-card",
            "fa-comment-alt",
            "fa-rss-square",
            "fa-paper-plane",
            "fa-webcam",
            "fa-inbox-out",
            "fa-bullhorn",
            "fa-bell-exclamation",
            "fa-address-book",
            "fa-mobile-android-alt",
            "fa-bell-plus",
            "fa-fax",
            "fa-envelope-open",
            "fa-voicemail",
            "fa-mobile-android",
            "fa-walkie-talkie",
            "fa-phone",
            "fa-broadcast-tower",
            "fa-bell-slash",
            "fa-comment",
            "fa-phone-slash"
        ]
    },
    {
        "label": "code",
        "icons": [
            "fa-brackets",
            "fa-qrcode",
            "fa-code-merge",
            "fa-bath",
            "fa-shield-check",
            "fa-browser",
            "fa-project-diagram",
            "fa-stream",
            "fa-folder",
            "fa-coffee",
            "fa-phone-laptop",
            "fa-filter",
            "fa-window-restore",
            "fa-shield-alt",
            "fa-window-maximize",
            "fa-fire-extinguisher",
            "fa-file",
            "fa-archive",
            "fa-microchip",
            "fa-code-branch",
            "fa-code-commit",
            "fa-laptop-code",
            "fa-sitemap",
            "fa-brackets-curly",
            "fa-shield",
            "fa-folder-open",
            "fa-bug",
            "fa-window",
            "fa-terminal",
            "fa-keyboard",
            "fa-file-alt",
            "fa-file-code",
            "fa-code",
            "fa-window-minimize",
            "fa-user-secret",
            "fa-window-close",
            "fa-barcode",
            "fa-window-alt"
        ]
    },
    {
        "label": "clothing",
        "icons": [
            "fa-hat-wizard",
            "fa-socks",
            "fa-graduation-cap",
            "fa-hat-witch",
            "fa-user-tie",
            "fa-ice-skate",
            "fa-tshirt",
            "fa-scarf",
            "fa-shoe-prints",
            "fa-boot",
            "fa-stocking",
            "fa-hat-winter",
            "fa-hat-santa",
            "fa-mitten",
            "fa-hat-cowboy",
            "fa-hat-cowboy-side",
            "fa-hood-cloak"
        ]
    },
    {
        "label": "childhood",
        "icons": [
            "fa-game-console-handheld",
            "fa-basketball-hoop",
            "fa-backpack",
            "fa-bell-school-slash",
            "fa-snowman",
            "fa-bath",
            "fa-birthday-cake",
            "fa-flashlight",
            "fa-duck",
            "fa-bell-school",
            "fa-baby",
            "fa-gamepad-alt",
            "fa-gamepad",
            "fa-baseball",
            "fa-cookie-bite",
            "fa-shapes",
            "fa-ice-cream",
            "fa-school",
            "fa-baby-carriage",
            "fa-robot",
            "fa-globe-snow",
            "fa-mitten",
            "fa-apple-alt",
            "fa-biking",
            "fa-cookie"
        ]
    },
    {
        "label": "chess",
        "icons": [
            "fa-chess",
            "fa-chess-rook",
            "fa-chess-board",
            "fa-chess-clock-alt",
            "fa-chess-queen-alt",
            "fa-chess-knight",
            "fa-chess-bishop",
            "fa-chess-pawn",
            "fa-game-board",
            "fa-chess-clock",
            "fa-chess-king",
            "fa-game-board-alt",
            "fa-chess-rook-alt",
            "fa-chess-bishop-alt",
            "fa-chess-knight-alt",
            "fa-chess-king-alt",
            "fa-chess-pawn-alt",
            "fa-square-full",
            "fa-chess-queen"
        ]
    },
    {
        "label": "chat",
        "icons": [
            "fa-phone-plus",
            "fa-comment-dots",
            "fa-video-slash",
            "fa-icons-alt",
            "fa-comment-alt-dots",
            "fa-frown",
            "fa-phone-alt",
            "fa-icons",
            "fa-video",
            "fa-comment-smile",
            "fa-meh",
            "fa-comment-slash",
            "fa-comment-music",
            "fa-comment-edit",
            "fa-comment-exclamation",
            "fa-comment-alt-slash",
            "fa-comment-medical",
            "fa-comment-times",
            "fa-video-plus",
            "fa-comments",
            "fa-smile",
            "fa-sms",
            "fa-comment-alt",
            "fa-quote-right",
            "fa-comment-minus",
            "fa-comments-alt",
            "fa-comment-alt-exclamation",
            "fa-comment-alt-times",
            "fa-comment-alt-plus",
            "fa-smile-plus",
            "fa-quote-left",
            "fa-comment-lines",
            "fa-comment-alt-lines",
            "fa-comment-alt-medical",
            "fa-poo",
            "fa-comment-plus",
            "fa-comment-check",
            "fa-comment-alt-minus",
            "fa-comment-alt-check",
            "fa-comment-alt-edit",
            "fa-phone",
            "fa-comment-alt-smile",
            "fa-comment",
            "fa-phone-slash"
        ]
    },
    {
        "label": "charity",
        "icons": [
            "fa-home-heart",
            "fa-hands-usd",
            "fa-box-heart",
            "fa-donate",
            "fa-ribbon",
            "fa-money-check-edit-alt",
            "fa-dollar-sign",
            "fa-handshake-alt",
            "fa-leaf-heart",
            "fa-globe",
            "fa-seedling",
            "fa-parachute-box",
            "fa-hand-heart",
            "fa-book-heart",
            "fa-usd-circle",
            "fa-heart",
            "fa-leaf",
            "fa-handshake",
            "fa-hand-holding-usd",
            "fa-hands-helping",
            "fa-gift",
            "fa-hand-holding-water",
            "fa-hand-holding-heart",
            "fa-usd-square",
            "fa-heart-square",
            "fa-box-usd",
            "fa-hands-heart",
            "fa-heart-circle",
            "fa-piggy-bank",
            "fa-money-check-edit",
            "fa-hand-holding-seedling",
            "fa-dove"
        ]
    },
    {
        "label": "camping",
        "icons": [
            "fa-map-signs",
            "fa-map",
            "fa-tree",
            "fa-backpack",
            "fa-caravan-alt",
            "fa-map-marked-alt",
            "fa-shish-kebab",
            "fa-binoculars",
            "fa-hiking",
            "fa-flashlight",
            "fa-map-marked",
            "fa-mountain",
            "fa-axe",
            "fa-rv",
            "fa-fire-alt",
            "fa-sunset",
            "fa-toilet-paper-alt",
            "fa-sunrise",
            "fa-toilet-paper",
            "fa-trees",
            "fa-shovel",
            "fa-cauldron",
            "fa-frog",
            "fa-boot",
            "fa-compass",
            "fa-route",
            "fa-caravan",
            "fa-tree-large",
            "fa-faucet",
            "fa-mountains",
            "fa-fire",
            "fa-fire-smoke",
            "fa-faucet-drip",
            "fa-acorn",
            "fa-campground",
            "fa-biking-mountain",
            "fa-tree-alt",
            "fa-campfire",
            "fa-squirrel",
            "fa-first-aid",
            "fa-trailer"
        ]
    },
    {
        "label": "business",
        "icons": [
            "fa-laptop-house",
            "fa-folder-minus",
            "fa-file-chart-line",
            "fa-columns",
            "fa-phone-volume",
            "fa-pencil-alt",
            "fa-tags",
            "fa-phone-square",
            "fa-lamp-desk",
            "fa-computer-classic",
            "fa-phone-alt",
            "fa-calculator",
            "fa-folders",
            "fa-keynote",
            "fa-podium",
            "fa-file-spreadsheet",
            "fa-percent",
            "fa-chart-pie-alt",
            "fa-registered",
            "fa-money-check-edit-alt",
            "fa-user-chart",
            "fa-chart-line-down",
            "fa-envelope-square",
            "fa-socks",
            "fa-marker",
            "fa-phone-office",
            "fa-sticky-note",
            "fa-industry",
            "fa-phone-square-alt",
            "fa-birthday-cake",
            "fa-pen-nib",
            "fa-save",
            "fa-envelope",
            "fa-project-diagram",
            "fa-highlighter",
            "fa-landmark",
            "fa-paste",
            "fa-folder-download",
            "fa-print",
            "fa-pencil",
            "fa-shredder",
            "fa-mind-share",
            "fa-print-slash",
            "fa-tasks",
            "fa-business-time",
            "fa-stream",
            "fa-badge-dollar",
            "fa-city",
            "fa-folder",
            "fa-coffee",
            "fa-pen-square",
            "fa-scanner-image",
            "fa-badge-check",
            "fa-globe",
            "fa-chart-scatter",
            "fa-coffee-pot",
            "fa-calendar-alt",
            "fa-eraser",
            "fa-thumbtack",
            "fa-router",
            "fa-book",
            "fa-tag",
            "fa-copyright",
            "fa-balance-scale",
            "fa-address-card",
            "fa-chart-line",
            "fa-copy",
            "fa-table",
            "fa-bullseye",
            "fa-briefcase",
            "fa-file",
            "fa-compass",
            "fa-archive",
            "fa-folder-upload",
            "fa-trademark",
            "fa-industry-alt",
            "fa-chart-bar",
            "fa-presentation",
            "fa-sitemap",
            "fa-file-user",
            "fa-calendar",
            "fa-balance-scale-left",
            "fa-folder-plus",
            "fa-edit",
            "fa-paperclip",
            "fa-bullhorn",
            "fa-tasks-alt",
            "fa-address-book",
            "fa-pen-alt",
            "fa-chart-network",
            "fa-folder-open",
            "fa-clipboard",
            "fa-certificate",
            "fa-file-chart-pie",
            "fa-folder-times",
            "fa-chart-pie",
            "fa-chart-area",
            "fa-fax",
            "fa-envelope-open",
            "fa-file-alt",
            "fa-balance-scale-right",
            "fa-badge-percent",
            "fa-phone",
            "fa-pen-fancy",
            "fa-building",
            "fa-wallet",
            "fa-cut",
            "fa-money-check-edit",
            "fa-cabinet-filing",
            "fa-glasses",
            "fa-projector",
            "fa-badge",
            "fa-folder-tree",
            "fa-pen",
            "fa-phone-slash"
        ]
    },
    {
        "label": "buildings",
        "icons": [
            "fa-church",
            "fa-archway",
            "fa-garage",
            "fa-house-damage",
            "fa-house",
            "fa-monument",
            "fa-home-alt",
            "fa-industry",
            "fa-house-day",
            "fa-car-building",
            "fa-house-night",
            "fa-chimney",
            "fa-hospitals",
            "fa-landmark",
            "fa-hospital",
            "fa-warehouse",
            "fa-farm",
            "fa-store-alt",
            "fa-house-flood",
            "fa-gopuram",
            "fa-city",
            "fa-garage-open",
            "fa-mosque",
            "fa-home",
            "fa-home-lg-alt",
            "fa-landmark-alt",
            "fa-vihara",
            "fa-industry-alt",
            "fa-hospital-user",
            "fa-hospital-alt",
            "fa-hotel",
            "fa-school",
            "fa-container-storage",
            "fa-campground",
            "fa-place-of-worship",
            "fa-torii-gate",
            "fa-clinic-medical",
            "fa-igloo",
            "fa-warehouse-alt",
            "fa-kaaba",
            "fa-garage-car",
            "fa-building",
            "fa-home-lg",
            "fa-store",
            "fa-university",
            "fa-synagogue",
            "fa-dungeon"
        ]
    },
    {
        "label": "beverage",
        "icons": [
            "fa-cocktail",
            "fa-jug",
            "fa-glass-whiskey",
            "fa-glass-martini-alt",
            "fa-coffee-togo",
            "fa-glass-champagne",
            "fa-blender",
            "fa-glass-martini",
            "fa-coffee",
            "fa-wine-glass-alt",
            "fa-coffee-pot",
            "fa-mug",
            "fa-flask-potion",
            "fa-wine-bottle",
            "fa-flask",
            "fa-wine-glass",
            "fa-burger-soda",
            "fa-glass-citrus",
            "fa-flask-poison",
            "fa-glass-whiskey-rocks",
            "fa-mug-hot",
            "fa-mug-tea",
            "fa-beer",
            "fa-glass",
            "fa-glass-cheers",
            "fa-mug-marshmallows"
        ]
    },
    {
        "label": "autumn",
        "icons": [
            "fa-corn",
            "fa-tree",
            "fa-pie",
            "fa-drumstick",
            "fa-turkey",
            "fa-coffee-togo",
            "fa-hiking",
            "fa-kite",
            "fa-mountain",
            "fa-axe",
            "fa-pumpkin",
            "fa-trees",
            "fa-shovel",
            "fa-wine-bottle",
            "fa-wheat",
            "fa-tractor",
            "fa-football-ball",
            "fa-mountains",
            "fa-leaf-oak",
            "fa-acorn",
            "fa-leaf-maple",
            "fa-apple-crate",
            "fa-mug-tea",
            "fa-campground",
            "fa-wind",
            "fa-apple-alt",
            "fa-cloud-sun",
            "fa-tree-alt",
            "fa-campfire",
            "fa-drumstick-bite",
            "fa-squirrel"
        ]
    },
    {
        "label": "automotive",
        "icons": [
            "fa-tachometer-slow",
            "fa-tire-rugged",
            "fa-garage",
            "fa-caravan-alt",
            "fa-oil-temp",
            "fa-tachometer-fastest",
            "fa-shuttle-van",
            "fa-car",
            "fa-car-building",
            "fa-tire-pressure-warning",
            "fa-car-bus",
            "fa-tachometer-alt-fast",
            "fa-tire",
            "fa-motorcycle",
            "fa-truck",
            "fa-car-wash",
            "fa-gas-pump-slash",
            "fa-garage-open",
            "fa-rv",
            "fa-car-tilt",
            "fa-air-freshener",
            "fa-ambulance",
            "fa-car-mechanic",
            "fa-bus-alt",
            "fa-car-battery",
            "fa-tachometer-slowest",
            "fa-car-side",
            "fa-tachometer",
            "fa-car-bump",
            "fa-car-garage",
            "fa-caravan",
            "fa-charging-station",
            "fa-tire-flat",
            "fa-truck-pickup",
            "fa-tachometer-fast",
            "fa-tachometer-alt-average",
            "fa-tachometer-alt-slow",
            "fa-tachometer-alt-slowest",
            "fa-gas-pump",
            "fa-oil-can",
            "fa-tachometer-alt-fastest",
            "fa-garage-car",
            "fa-car-alt",
            "fa-taxi",
            "fa-flux-capacitor",
            "fa-bus",
            "fa-car-crash",
            "fa-tachometer-alt",
            "fa-steering-wheel",
            "fa-tachometer-average",
            "fa-wagon-covered",
            "fa-engine-warning",
            "fa-truck-monster",
            "fa-cars",
            "fa-trailer"
        ]
    },
    {
        "label": "audio-video",
        "icons": [
            "fa-drone",
            "fa-play",
            "fa-rss",
            "fa-random",
            "fa-amp-guitar",
            "fa-phone-volume",
            "fa-step-forward",
            "fa-volume-mute",
            "fa-image-polaroid",
            "fa-undo-alt",
            "fa-tv",
            "fa-expand-arrows",
            "fa-play-circle",
            "fa-redo-alt",
            "fa-camcorder",
            "fa-microphone-alt",
            "fa-betamax",
            "fa-sync-alt",
            "fa-microphone",
            "fa-microphone-slash",
            "fa-pause-circle",
            "fa-expand",
            "fa-repeat-alt",
            "fa-podcast",
            "fa-vhs",
            "fa-compress",
            "fa-video",
            "fa-file-video",
            "fa-eject",
            "fa-microphone-alt-slash",
            "fa-waveform",
            "fa-volume-slash",
            "fa-rectangle-portrait",
            "fa-waveform-path",
            "fa-volume-off",
            "fa-repeat-1-alt",
            "fa-film-alt",
            "fa-signal-stream",
            "fa-expand-wide",
            "fa-volume-up",
            "fa-webcam-slash",
            "fa-repeat-1",
            "fa-speaker",
            "fa-cloud-music",
            "fa-volume",
            "fa-file-audio",
            "fa-film-canister",
            "fa-microphone-stand",
            "fa-camera-home",
            "fa-album",
            "fa-camera-polaroid",
            "fa-stop-circle",
            "fa-computer-speaker",
            "fa-rectangle-wide",
            "fa-sync",
            "fa-music",
            "fa-expand-alt",
            "fa-album-collection",
            "fa-step-backward",
            "fa-rss-square",
            "fa-volume-down",
            "fa-closed-captioning",
            "fa-scrubber",
            "fa-headphones",
            "fa-head-side-headphones",
            "fa-drone-alt",
            "fa-webcam",
            "fa-fast-backward",
            "fa-compress-alt",
            "fa-pause",
            "fa-compress-arrows-alt",
            "fa-speakers",
            "fa-photo-video",
            "fa-undo",
            "fa-film",
            "fa-compress-wide",
            "fa-expand-arrows-alt",
            "fa-backward",
            "fa-mp3-player",
            "fa-camera-movie",
            "fa-audio-description",
            "fa-tv-alt",
            "fa-fast-forward",
            "fa-youtube",
            "fa-stop",
            "fa-redo",
            "fa-repeat",
            "fa-broadcast-tower",
            "fa-rectangle-landscape",
            "fa-forward",
            "fa-projector",
            "fa-circle",
            "fa-boombox"
        ]
    },
    {
        "label": "arrows",
        "icons": [
            "fa-arrow-circle-up",
            "fa-arrow-circle-down",
            "fa-play",
            "fa-arrow-square-down",
            "fa-arrow-alt-from-left",
            "fa-history",
            "fa-arrow-to-right",
            "fa-random",
            "fa-sort-numeric-down-alt",
            "fa-cloud-upload-alt",
            "fa-undo-alt",
            "fa-caret-circle-right",
            "fa-expand-arrows",
            "fa-retweet-alt",
            "fa-chevron-left",
            "fa-level-down",
            "fa-arrow-from-top",
            "fa-arrow-alt-from-right",
            "fa-redo-alt",
            "fa-sort-numeric-up-alt",
            "fa-arrow-square-up",
            "fa-arrows-alt-h",
            "fa-sort-alpha-up",
            "fa-sign-out-alt",
            "fa-recycle",
            "fa-sync-alt",
            "fa-sort-numeric-up",
            "fa-angle-up",
            "fa-caret-square-up",
            "fa-sort-size-down-alt",
            "fa-angle-double-down",
            "fa-repeat-alt",
            "fa-chevron-double-left",
            "fa-arrow-square-right",
            "fa-text-height",
            "fa-inbox-in",
            "fa-chevron-square-left",
            "fa-sort-amount-down",
            "fa-chevron-double-down",
            "fa-arrow-to-bottom",
            "fa-reply-all",
            "fa-download",
            "fa-repeat-1-alt",
            "fa-cloud-download-alt",
            "fa-arrow-from-left",
            "fa-chevron-square-down",
            "fa-sort-size-down",
            "fa-repeat-1",
            "fa-arrow-alt-square-left",
            "fa-sort-size-up",
            "fa-retweet",
            "fa-long-arrow-down",
            "fa-arrow-from-right",
            "fa-long-arrow-alt-up",
            "fa-hand-point-up",
            "fa-sort-shapes-down",
            "fa-external-link-square",
            "fa-chevron-square-up",
            "fa-long-arrow-left",
            "fa-hand-pointer",
            "fa-arrow-alt-circle-right",
            "fa-arrow-up",
            "fa-arrow-down",
            "fa-arrow-alt-square-right",
            "fa-arrow-from-bottom",
            "fa-exchange",
            "fa-arrow-square-left",
            "fa-reply",
            "fa-caret-square-right",
            "fa-angle-double-left",
            "fa-sort",
            "fa-caret-square-down",
            "fa-long-arrow-alt-left",
            "fa-arrow-left",
            "fa-chevron-circle-left",
            "fa-arrows",
            "fa-chevron-circle-right",
            "fa-arrow-alt-left",
            "fa-sync",
            "fa-sort-shapes-down-alt",
            "fa-sign-in",
            "fa-sort-alt",
            "fa-expand-alt",
            "fa-cloud-upload",
            "fa-chart-line",
            "fa-arrow-alt-to-bottom",
            "fa-arrow-alt-to-top",
            "fa-long-arrow-alt-down",
            "fa-long-arrow-up",
            "fa-location-arrow",
            "fa-sort-shapes-up-alt",
            "fa-chevron-double-up",
            "fa-arrow-to-top",
            "fa-angle-down",
            "fa-arrow-alt-to-left",
            "fa-text-width",
            "fa-chevron-down",
            "fa-arrow-alt-right",
            "fa-angle-right",
            "fa-caret-up",
            "fa-hand-point-left",
            "fa-arrow-alt-square-down",
            "fa-arrows-h",
            "fa-sort-up",
            "fa-sort-alpha-up-alt",
            "fa-sort-shapes-up",
            "fa-arrow-alt-from-bottom",
            "fa-arrow-alt-down",
            "fa-triangle",
            "fa-chevron-right",
            "fa-long-arrow-right",
            "fa-angle-left",
            "fa-compress-alt",
            "fa-chevron-double-right",
            "fa-level-up-alt",
            "fa-angle-double-up",
            "fa-inbox-out",
            "fa-compress-arrows-alt",
            "fa-sort-amount-up",
            "fa-sort-amount-up-alt",
            "fa-caret-circle-up",
            "fa-arrow-circle-right",
            "fa-caret-circle-left",
            "fa-undo",
            "fa-arrow-alt-circle-left",
            "fa-external-link-square-alt",
            "fa-arrow-alt-circle-down",
            "fa-angle-double-right",
            "fa-chevron-circle-up",
            "fa-cart-arrow-down",
            "fa-caret-down",
            "fa-expand-arrows-alt",
            "fa-exchange-alt",
            "fa-arrow-alt-from-top",
            "fa-level-down-alt",
            "fa-sort-alpha-down",
            "fa-upload",
            "fa-arrows-alt-v",
            "fa-long-arrow-alt-right",
            "fa-chevron-square-right",
            "fa-hand-point-down",
            "fa-sign-out",
            "fa-chevron-up",
            "fa-sort-size-up-alt",
            "fa-sort-down",
            "fa-caret-square-left",
            "fa-redo",
            "fa-arrow-right",
            "fa-sign-in-alt",
            "fa-arrow-alt-up",
            "fa-repeat",
            "fa-sort-alpha-down-alt",
            "fa-caret-left",
            "fa-arrows-v",
            "fa-sort-amount-down-alt",
            "fa-arrow-to-left",
            "fa-share-square",
            "fa-chevron-circle-down",
            "fa-arrow-circle-left",
            "fa-arrows-alt",
            "fa-cloud-download",
            "fa-share",
            "fa-level-up",
            "fa-mouse-pointer",
            "fa-caret-right",
            "fa-share-all",
            "fa-external-link-alt",
            "fa-sort-numeric-down",
            "fa-external-link",
            "fa-arrow-alt-circle-up",
            "fa-caret-circle-down",
            "fa-arrow-alt-to-right",
            "fa-hand-point-right",
            "fa-arrow-alt-square-up"
        ]
    },
    {
        "label": "animals",
        "icons": [
            "fa-horse-saddle",
            "fa-hippo",
            "fa-feather",
            "fa-dog",
            "fa-monkey",
            "fa-spider",
            "fa-cow",
            "fa-unicorn",
            "fa-paw",
            "fa-spider-black-widow",
            "fa-duck",
            "fa-paw-claws",
            "fa-dog-leashed",
            "fa-otter",
            "fa-snake",
            "fa-rabbit-fast",
            "fa-cat",
            "fa-pig",
            "fa-ram",
            "fa-pegasus",
            "fa-fish",
            "fa-deer-rudolph",
            "fa-frog",
            "fa-horse-head",
            "fa-horse",
            "fa-feather-alt",
            "fa-alicorn",
            "fa-skull-cow",
            "fa-badger-honey",
            "fa-crow",
            "fa-elephant",
            "fa-deer",
            "fa-rabbit",
            "fa-turtle",
            "fa-sheep",
            "fa-dragon",
            "fa-kiwi-bird",
            "fa-cat-space",
            "fa-whale",
            "fa-bat",
            "fa-narwhal",
            "fa-dove",
            "fa-paw-alt",
            "fa-squirrel"
        ]
    },
    {
        "label": "alert",
        "icons": [
            "fa-exclamation-triangle",
            "fa-wind-warning",
            "fa-star-exclamation",
            "fa-bell-school-slash",
            "fa-alarm-clock",
            "fa-alarm-exclamation",
            "fa-exclamation-square",
            "fa-bell",
            "fa-calendar-exclamation",
            "fa-lightbulb-exclamation",
            "fa-comment-exclamation",
            "fa-sensor-on",
            "fa-radiation-alt",
            "fa-bell-on",
            "fa-file-exclamation",
            "fa-bells",
            "fa-sensor",
            "fa-comment-alt-exclamation",
            "fa-exclamation",
            "fa-map-marker-exclamation",
            "fa-bell-exclamation",
            "fa-sensor-smoke",
            "fa-sensor-fire",
            "fa-skull-crossbones",
            "fa-radiation",
            "fa-exclamation-circle",
            "fa-bell-slash",
            "fa-engine-warning",
            "fa-sensor-alert"
        ]
    },
    {
        "label": "accessibility",
        "icons": [
            "fa-phone-volume",
            "fa-wheelchair",
            "fa-tty",
            "fa-question-circle",
            "fa-universal-access",
            "fa-blind",
            "fa-dog-leashed",
            "fa-sign-language",
            "fa-assistive-listening-systems",
            "fa-low-vision",
            "fa-american-sign-language-interpreting",
            "fa-braille",
            "fa-closed-captioning",
            "fa-deaf",
            "fa-accessible-icon",
            "fa-audio-description"
        ]
    }
];
//# sourceMappingURL=icons.json.js.map